/**
 * Created with IntelliJ IDEA.
 * User: omerh
 * Date: 3/20/13
 * Time: 5:42 PM
 * To change this template use File | Settings | File Templates.
 */
define(function () {
    "use strict";

    var Dictionary = {
        "language": "en-US",
        "exampleList.header": "Translated by Example dictionary",
        //Engagement widget
        "consumerTyping": "Consumer is typing...",
        "participantTyping": "Visitor is typing...",
        "participantSingleNewMessage": "1 new message",
        "participantNewMessages": "{0} new messages",
        "participantDefaultName": "Visitor",
        "autoMessageBotDefaultName": "info",
        "agentDefaultName": "Agent",
        "hideEngagement": "Hide engagement",
        "hideConversation": "Hide conversation",
        "returnToQueue": "Return conversation to queue",//// MYWORD_COMPANY_LENGTH_28
        "closeConversation": "Close conversation",
        "leaveConversation": "Leave conversation",

        "CRMLink": "Open CRM window.",
        "add": "Add",

        //Accessible Text
        "refreshLabel": "Refresh",
        "firstInput": "First",
        "secondInput": "Second",
        "date": "Date",
        "time": "Time",
        "agentStatus": "Agent Status",
        "previousArrowTitle": "Previous widgets",
        "nextArrowTitle": "Next widgets",

        //Chat
        "chatHasEnded": "Chat has ended.",
        "chatHasTransferred": "Chat has been transferred.",
        "chatTransferTimeText": "Chat transferred: ",
        "chatEndTimeText": "Chat ended: ",
        "chatDurationText": "Duration: ",
        "chatPrivateLine": "Private",
        "chatAutomatedLine": "Automated",
        "averageWaitTime" : "Average wait time",
        "moreChatOptions": "See more options for this chat",

        //State widget
        "online": "Online",
        "backIn5": "Back Soon",
        "back_soon": "Back Soon",
        "away": "Away",
        "offline": "Offline",
        "processingStatus": "Processing...",
        "statusDiscrepancy": "Please choose",

        //Account widget
        "aw_agentName": "Name :",
        "signOut": "Logout",
        "account": "Account :",
        "enableDebug": "Enable logs",
        "disableDebug": "Disable logs",
        "muteSounds": "Sound is Off",
        "playSounds": "Sound is On",
        "version": "{{buildVersion}}",

        //Login widget
        "accountCaps": "ACCOUNT:",
        "userNameCaps": "USERNAME:",
        "passwordCaps": "PASSWORD:",
        "loginErrorAccount": "The account number you provided is not valid.",
        "loginErrorLocked": "You are currently unable to sign in. This could be due to a disabled account or the maximum agent limit has been reached.",
        "loginErrorCredentials": "There was an error signing in, verify your credentials.",
        "loginHeader": "LiveEngage Visitor Engagement Area",
        "forgotAccount": "Forgot account number?",
        "forgotPassword": "Forgot password?",
        "rememberMe": "Remember me.",
        "signIn": "Sign in",
        "mandatoryMissing": "Complete all missing fields.",

        //Agent notifications
        "agentNotification.AcceptedChatSingle": "You have accepted 1 new engagement.",
        "agentNotification.AcceptedChatMulti": "You have accepted {0} new engagements.",
        "agentNotification.NewLineSingle": "You have 1 unread message.",
        "agentNotification.NewLineMulti": "You have {0} unread messages.",
        "agentNotification.NewRequestSingle": "You have 1 new chat request.",
        "agentNotification.NewRequestMulti": "You have {0} new chat requests.",
        "agentNotification.OpenConversationSingle": "You have 1 new conversation request.",
        "agentNotification.OpenConversationMulti": "You have {0} new conversation requests.",
        //Agent tab notifications
        "agentTabNotificationSingle": "new notification",
        "agentTabNotificationMulti": "new notifications",
        //Agent Desktop notifications
        "agentDesktopNotification.NewLineSingle": "{0} sent you a new message",
        "agentDesktopNotification.NewWidgetNotification": "New notification from {0}",
        "agentDesktopNotification.AcceptedChatSingle": "You have accepted a new engagement",
        "agentDesktopNotification.NewRequestSingle": "New incoming chat",
        "agentDesktopNotification.NewRequestBodySingle": "You have 1 new chat waiting",
        "agentDesktopNotification.NewRequestBodyMulti": "You have a total of {0} new chats waiting",
        "agentDesktopNotification.NewOpenConversationSingle": "New incoming conversation",
        "agentDesktopNotification.NewOpenConversationBodySingle": "You have 1 new conversation waiting",
        "agentDesktopNotification.NewOpenConversationBodyMulti": "You have a total of {0} new conversations waiting",

        // Agent Paste Dialog Notifications.
        "agentDialogsNotifications.PasteToEditorNotification.title": "Keep our customer information safe",
        "agentDialogsNotifications.PasteToEditorNotification.description": "Please confirm this message content belongs to this customer",

        // Agent Summary widget
        "agentSummaryTextareaTitle": "Conversation summary:",
        "agentSummaryTextareaPlaceholder": "Enter summary...",
        "agentSummaryDisabledMessage": "Conversation has been closed for {0} days, Conversation summary can not be submitted",

        //Agent Actions widget
        "AgentActionsWidgetContainer": "Conversation summary",

        //Agent on-behalf widget
        "conversationOutcomes" : "Conversation outcomes",

        //Agent outcomes widget - Submit SDEs on behalf
        "agentOutComesSubmit" : "Submit",

        //SDE title mappings
        "purchaseTitle" : "Purchase",
        "leadTitle" : "Lead",
        "serviceTitle" : "Service",

        //SDE states
        "sdeNoFieldsFilled": "Please fill in at least one field prior to submission",
        "sdeSubmissionError": "Failed to submit the SDE, please refill and try again",
        "sdeSubmissionNotPossibleError": "You can no longer submit data for this engagement",
        "sdeSubmissionValidationError" : "One of the submitted fields is invalid",
        "sdeSubmissionSuccess": "Data successfully added to session",

        //SDE property mappings to default
        "purchasetotal" : "Total",
        "purchaseorderId" : "Order ID",
        "purchasecurrency": "Currency",
        "leadcurrency": "Currency",
        "leadtopic" : "Topic",
        "leadvalue" : "Value",
        "leadleadId" : "Lead ID",
        "servicetopic" : "Topic",
        "servicestatus": "Status",
        "servicecategory": "Category",
        "serviceserviceId": "Service ID",
        "servicestatusdefault" : "Pick a status",

        //Agent Survey widget
        "agentSurvey": "Agent survey",
        "surveyErrorsGeneral": "A required field is missing or one or more fields are not valid. Correct the information and resubmit the survey.",
        "surveyErrorsNoSurvey": "A survey needs to be set up for this chat.",
        "SurveyIsInactive": "Survey is inactive",
        "surveyErrorsNoChat": "There is no chat associated with this session.",
        "surveyErrorsSubmissionFailure": "There was a problem submitting this survey.",
        "surveySubmitted": "The survey has been submitted.",
        "defaultSelectValue": "Select an option.",
        "surveySubmit": "Done",
        "retryButtonTitle": "Retry",
        "surveyFormFieldError": "The entered value is invalid.",

        //Chat history widget
        "past_engagements": "Past engagements",
        "empty_chat_history_msg": "No history records to display.",
        "error_chat_history_msg": "Error loading past engagements.",
        "chatHistoryError": "Could not load the conversation history.",
        "chatDurationTranscriptText": "Duration",

        "engagementsHistory_csatTitle" : "CSAT",
        "engagementsHistory_CSAT_CalcInfo_tooltip": "Aggregated CSAT based on {0} out of {1} conversations in which the consumer filled out a CSAT survey",

        "surveySubmitRequiredTitle": "Submit survey",
        "surveySubmitRequiredDescription": "You did not submit a survey for this engagement. Are you sure you want to close it?",
        "surveySubmitRequiredOkButton": "Close engagement",
        "surveySubmitRequiredCancelButton": "Cancel",

        //Canned Answers widget
        "preDefinedContent": "Predefined content",
        "preDefinedContentErrorsNoPredefinedContent": "This chat does not have the recommended Predefined Content.",
        "preDefinedContentErrorsNoChat": "There is no chat associated with this session.",

        //Offline orb widget
        "offLine": "Closed",
        "OfflineOrbViewController_clearAll": "Clear all",
        "OfflineOrbViewController_clearAll_tooltip": "Clear all closed engagements",
        "OfflineOrbViewController_clearAllCompleted": "Clear all completed",
        "OfflineOrbViewController_clearAllCompleted_tooltip": "Clear all conversations with no pending surveys",

        // Engagement orb
        "engagementOrbVisitorClosedConnectionNotification": "The visitor has ended the engagement.",
        "engagementOrbChatClosedConnectionNotification": "The conversation has ended.",
        "conversationOrbConsumerClosedConnectionNotification": "The consumer closed the conversation.",
        "conversationOrbAgentManagerClosedConnectionNotification": "Conversation was closed.",
        "conversationOrbAutoClosedConnectionNotification": "The system auto closed the conversation.",
        "conversationOrbTakeoverClosedConnectionNotification": "Conversation was taken over by {0}.",
        "engagementOrbCoBrowseSessionStarted": "CoBrowse session started",
        "engagementOrbCoBrowseSessionEnded": "CoBrowse session ended",
        "engagementOrbCoBrowseSessionFailed": "CoBrowse session failed",
        "engagementOrbCoBrowseOfferTimeOut": "CoBrowse invitation timed out",
        "engagementOrbCoBrowseOfferDeclined": "CoBrowse invitation declined",
        "engagementOrbCallAccepted": "'{0}' accepted your call",
        "engagementOrbCallEnded": "Call has ended",
        "engagementOrbCallMissed": "'{0}' missed your call",
        "engagementOrbCallDeclined": "'{0}' declined your call",
        "engagementOrbStepUpNotification": "This conversation has been authenticated",
        //Queue orb widget
        "waitingInQueue": "Waiting",
        "accept": "Accept",
        "waitForChatAccept": "Accepting",

        "VisitorInfoViewController_email": "Contact email address",
        "VisitorInfoViewController_geoCountry": "Country",
        "VisitorInfoViewController_country": "Country",
        "VisitorInfoViewController_os": "Operating system",
        "VisitorInfoViewController_operatingSystem": "Operating system",
        "VisitorInfoViewController_geoTimeZone": "Time zone",
        "VisitorInfoViewController_skill": "Skill",
        "VisitorInfoViewController_browser": "Browser",
        "VisitorInfoViewController_currentPage": "Current page",
        "VisitorInfoViewController_previousPages": "Previous pages",
        "VisitorInfoViewController_navigationHistory": "Page navigation",
        "VisitorInfoViewController_startPageTitle": "Page",
        "VisitorInfoViewController_maxPageTitle": "of",
        "VisitorInfoViewController_sso": "SSO",
        "VisitorInfoViewController_ip": "IP",
        "VisitorInfoViewController_ipAddress": "IP",
        "VisitorInfoViewController_state": "State",
        "VisitorInfoViewController_title": "Page title",
        "VisitorInfoViewController_engagementStartTime": "Engagement start",
        "VisitorInfoViewController_visitStartTime": "Visit start",
        "VisitorInfoViewController_contactID": "Identifier",
        "VisitorInfoViewController_geoCity": "City",
        "VisitorInfoViewController_geoOrg": "Organization",
        "VisitorInfoViewController_startTime": "Start time",
        "VisitorInfoViewController_endTime": "End time",
        "VisitorInfoViewController_duration": "Duration",
        "VisitorInfoViewController_visitorId": "Visitor ID",
        "VisitorInfoViewController_referrer": "Referrer",
        "VisitorInfoViewController_agentName": "Agent name",
        "VisitorInfoViewController_visitorName": "Visitor name",
        "VisitorInfoViewController_consumerName": "Consumer name",
        "VisitorInfoViewController_consumerId": "Consumer ID",
        "VisitorInfoViewController_conversationId": "Conversation ID",



        "showMore": "Show more",
        "showLess": "Show less",

        "noSkillFound": "N/A",
        "noSkillAvailable": "N/A",

        "notAvailable": "N/A",
        "showDetails": "Details",
        "unassigned": "Unassigned",
        "uncategorized": "Uncategorized",

        "inActiveSkill" : "Inactive skill",
        "inActiveAgent" : "Inactive agent",

        "noDataText": "No content to display",
        "dataFoundText": "Results updated below",

        // ---------------- Messaging items ------------------
        "colAgentName": "AGENT NAME",
        "consumerName": "CONSUMER NAME",
        "agentGroup": "AGENT GROUP",
        "conversationInfo": "Conversation Info",
        "phoneNumber": "MOBILE NUMBER",
        "phoneNumberTooltip": "Consumer mobile phone number",
        "CSAT": "CSAT",
        "CSATTooltip": "Customer satisfaction as provided by the consumer in the most recent conversation.",
        "SLA": "RESPONSE TIME",
        "SLATooltip": "Duration of time remaining until a response is required.",
        "SLA_days": "{0}d",
        "SLA_days_hours": "{0}d {1}h",
        "SLA_hours": "{0}h",
        "SLA_hours_minutes": "{0}h {1}m",
        "SLA_minutes": "{0}m",
        "SLATooltip_day": "1 day",
        "SLATooltip_day_hour": "1 day 1 hour",
        "SLATooltip_day_hours": "1 day {0} hours",
        "SLATooltip_day_hour_minute": "1 day 1 hour 1 minute",
        "SLATooltip_day_hour_minutes": "1 day 1 hour {0} minutes",
        "SLATooltip_day_hours_minute": "1 day {0} hours 1 minute",
        "SLATooltip_day_hours_minutes": "1 day {0} hours {1} minutes",
        "SLATooltip_day_hour_minute_second": "1 day 1 hour 1 minute 1 second",
        "SLATooltip_day_hour_minute_seconds": "1 day 1 hour 1 minute {0} seconds",
        "SLATooltip_day_hour_minutes_second": "1 day 1 hour {0} minutes 1 second",
        "SLATooltip_day_hour_minutes_seconds": "1 day 1 hour {0} minutes {1} seconds",
        "SLATooltip_day_hours_minute_second": "1 day {0} hours 1 minute 1 second",
        "SLATooltip_day_hours_minute_seconds": "1 day {0} hours 1 minute {1} seconds",
        "SLATooltip_day_hours_minutes_second": "1 day {0} hours {1} minutes 1 second",
        "SLATooltip_day_hours_minutes_seconds": "1 day {0} hours {1} minutes {2} seconds",
        "SLATooltip_day_hour_second": "1 day 1 hour 1 second",
        "SLATooltip_day_hour_seconds": "1 day 1 hour {0} seconds",
        "SLATooltip_day_hours_second": "1 day {0} hours 1 second",
        "SLATooltip_day_hours_seconds": "1 day {0} hours {1} seconds",
        "SLATooltip_day_minute_second": "1 day 1 minute 1 second",
        "SLATooltip_day_minute_seconds": "1 day 1 minute {0} seconds",
        "SLATooltip_day_minutes_second": "1 day {0} minutes 1 second",
        "SLATooltip_day_minutes_seconds": "1 day {0} minutes {1} seconds",
        "SLATooltip_day_minute": "1 day 1 minute",
        "SLATooltip_day_minutes": "1 day {0} minutes",
        "SLATooltip_day_second": "1 day 1 second",
        "SLATooltip_day_seconds": "1 day {0} seconds",
        "SLATooltip_days": "{0} days",
        "SLATooltip_days_hour": "{0} days 1 hour",
        "SLATooltip_days_hours": "{0} days {1} hours",
        "SLATooltip_days_hour_minute": "{0} days 1 hour 1 minute",
        "SLATooltip_days_hour_minutes": "{0} days 1 hour {1} minutes",
        "SLATooltip_days_hours_minute": "{0} days {1} hours 1 minute",
        "SLATooltip_days_hours_minutes": "{0} days {1} hours {2} minutes",
        "SLATooltip_days_hour_minute_second": "{0} days 1 hour 1 minute 1 second",
        "SLATooltip_days_hour_minute_seconds": "{0} days 1 hour 1 minute {1} seconds",
        "SLATooltip_days_hour_minutes_second": "{0} days 1 hour {1} minutes 1 second",
        "SLATooltip_days_hour_minutes_seconds": "{0} days 1 hour {1} minutes {2} seconds",
        "SLATooltip_days_hours_minute_second": "{0} days {1} hours 1 minute 1 second",
        "SLATooltip_days_hours_minute_seconds": "{0} days {1} hours 1 minute {2} seconds",
        "SLATooltip_days_hours_minutes_second": "{0} days {1} hours {2} minutes 1 second",
        "SLATooltip_days_hours_minutes_seconds": "{0} days {1} hours {2} minutes {3} seconds",
        "SLATooltip_days_hour_second": "{0} days 1 hour 1 second",
        "SLATooltip_days_hour_seconds": "{0} days 1 hour {1} seconds",
        "SLATooltip_days_hours_second": "{0} days {1} hours 1 second",
        "SLATooltip_days_hours_seconds": "{0} days {1} hours {2} seconds",
        "SLATooltip_days_minute_second": "{0} days 1 minute 1 second",
        "SLATooltip_days_minute_seconds": "{0} days 1 minute {0} seconds",
        "SLATooltip_days_minutes_second": "{0} days {1} minutes 1 second",
        "SLATooltip_days_minutes_seconds": "{0} days {1} minutes {2} seconds",
        "SLATooltip_days_minute": "{0} days 1 minute",
        "SLATooltip_days_minutes": "{0} days {1} minutes",
        "SLATooltip_days_second": "{0} days 1 second",
        "SLATooltip_days_seconds": "{0} days {1} seconds",
        "SLATooltip_hour": "1 hour",
        "SLATooltip_hours": "{0} hours",
        "SLATooltip_hour_minute": "1 hour 1 minute",
        "SLATooltip_hour_minutes": "1 hour {0} minutes",
        "SLATooltip_hours_minute": "{0} hours 1 minute",
        "SLATooltip_hours_minutes": "{0} hours {1} minutes",
        "SLATooltip_hour_minute_second": "1 hour 1 minute 1 second",
        "SLATooltip_hour_minute_seconds": "1 hour 1 minute {0} seconds",
        "SLATooltip_hour_minutes_second": "1 hour {0} minutes 1 second",
        "SLATooltip_hour_minutes_seconds": "1 hour {0} minutes {1} seconds",
        "SLATooltip_hours_minute_second": "{0} hours 1 minute 1 second",
        "SLATooltip_hours_minute_seconds": "{0} hours 1 minute {1} seconds",
        "SLATooltip_hours_minutes_second": "{0} hours {1} minutes 1 second",
        "SLATooltip_hours_minutes_seconds": "{0} hours {1} minutes {2} seconds",
        "SLATooltip_hour_second": "1 hour 1 second",
        "SLATooltip_hour_seconds": "1 hour {0} seconds",
        "SLATooltip_hours_second": "{0} hours 1 second",
        "SLATooltip_hours_seconds": "{0} hours {1} seconds",
        "SLATooltip_minute": "1 minute",
        "SLATooltip_minutes": "{0} minutes",
        "SLATooltip_minute_second": "1 minute 1 second",
        "SLATooltip_minute_seconds": "1 minute {0} seconds",
        "SLATooltip_minutes_second": "{0} minutes 1 second",
        "SLATooltip_minutes_seconds": "{0} minutes {1} seconds",
        "SLATooltip_second": "1 second",
        "SLATooltip_seconds": "{0} seconds",

        "SLATooltipOverdue": "overdue",
        "SLATooltipOverdue_day": "1 day overdue",
        "SLATooltipOverdue_day_hour": "1 day 1 hour overdue",
        "SLATooltipOverdue_day_hours": "1 day {0} hours overdue",
        "SLATooltipOverdue_day_hour_minute": "1 day 1 hour 1 minute overdue",
        "SLATooltipOverdue_day_hour_minutes": "1 day 1 hour {0} minutes overdue",
        "SLATooltipOverdue_day_hours_minute": "1 day {0} hours 1 minute overdue",
        "SLATooltipOverdue_day_hours_minutes": "1 day {0} hours {1} minutes overdue",
        "SLATooltipOverdue_day_hour_minute_second": "1 day 1 hour 1 minute 1 second overdue",
        "SLATooltipOverdue_day_hour_minute_seconds": "1 day 1 hour 1 minute {0} seconds overdue",
        "SLATooltipOverdue_day_hour_minutes_second": "1 day 1 hour {0} minutes 1 second overdue",
        "SLATooltipOverdue_day_hour_minutes_seconds": "1 day 1 hour {0} minutes {1} seconds overdue",
        "SLATooltipOverdue_day_hours_minute_second": "1 day {0} hours 1 minute 1 second overdue",
        "SLATooltipOverdue_day_hours_minute_seconds": "1 day {0} hours 1 minute {1} seconds overdue",
        "SLATooltipOverdue_day_hours_minutes_second": "1 day {0} hours {1} minutes 1 second overdue",
        "SLATooltipOverdue_day_hours_minutes_seconds": "1 day {0} hours {1} minutes {2} seconds overdue",
        "SLATooltipOverdue_day_hour_second": "1 day 1 hour 1 second overdue",
        "SLATooltipOverdue_day_hour_seconds": "1 day 1 hour {0} seconds overdue",
        "SLATooltipOverdue_day_hours_second": "1 day {0} hours 1 second overdue",
        "SLATooltipOverdue_day_hours_seconds": "1 day {0} hours {1} seconds overdue",
        "SLATooltipOverdue_day_minute_second": "1 day 1 minute 1 second overdue",
        "SLATooltipOverdue_day_minute_seconds": "1 day 1 minute {0} seconds overdue",
        "SLATooltipOverdue_day_minutes_second": "1 day {0} minutes 1 second overdue",
        "SLATooltipOverdue_day_minutes_seconds": "1 day {0} minutes {1} seconds overdue",
        "SLATooltipOverdue_day_minute": "1 day 1 minute {0} overdue",
        "SLATooltipOverdue_day_minutes": "1 day {0} minutes overdue",
        "SLATooltipOverdue_day_second": "1 day 1 second overdue",
        "SLATooltipOverdue_day_seconds": "1 day {0} seconds overdue",
        "SLATooltipOverdue_days": "{0} days overdue",
        "SLATooltipOverdue_days_hour": "{0} days 1 hour overdue",
        "SLATooltipOverdue_days_hours": "{0} days {1} hours overdue",
        "SLATooltipOverdue_days_hour_minute": "{0} days 1 hour 1 minute overdue",
        "SLATooltipOverdue_days_hour_minutes": "{0} days 1 hour {1} minutes overdue",
        "SLATooltipOverdue_days_hours_minute": "{0} days {1} hours 1 minute overdue",
        "SLATooltipOverdue_days_hours_minutes": "{0} days {1} hours {2} minutes overdue",
        "SLATooltipOverdue_days_hour_minute_second": "{0} days 1 hour 1 minute 1 second overdue",
        "SLATooltipOverdue_days_hour_minute_seconds": "{0} days 1 hour 1 minute {1} seconds overdue",
        "SLATooltipOverdue_days_hour_minutes_second": "{0} days 1 hour {1} minutes 1 second overdue",
        "SLATooltipOverdue_days_hour_minutes_seconds": "{0} days 1 hour {1} minutes {2} seconds overdue",
        "SLATooltipOverdue_days_hours_minute_second": "{0} days {1} hours 1 minute 1 second overdue",
        "SLATooltipOverdue_days_hours_minute_seconds": "{0} days {1} hours 1 minute {2} seconds overdue",
        "SLATooltipOverdue_days_hours_minutes_second": "{0} days {1} hours {2} minutes 1 second overdue",
        "SLATooltipOverdue_days_hours_minutes_seconds": "{0} days {1} hours {2} minutes {3} seconds overdue",
        "SLATooltipOverdue_days_hour_second": "{0} days 1 hour 1 second overdue",
        "SLATooltipOverdue_days_hour_seconds": "{0} days 1 hour {1} seconds overdue",
        "SLATooltipOverdue_days_hours_second": "{0} days {1} hours 1 second overdue",
        "SLATooltipOverdue_days_hours_seconds": "{0} days {1} hours {2} seconds overdue",
        "SLATooltipOverdue_days_minute_second": "{0} days 1 minute 1 second overdue",
        "SLATooltipOverdue_days_minute_seconds": "{0} days 1 minute {0} seconds overdue",
        "SLATooltipOverdue_days_minutes_second": "{0} days {1} minutes 1 second overdue",
        "SLATooltipOverdue_days_minutes_seconds": "{0} days {1} minutes {2} seconds overdue",
        "SLATooltipOverdue_days_minute": "{0} days 1 minute {2} overdue",
        "SLATooltipOverdue_days_minutes": "{0} days {1} minutes overdue",
        "SLATooltipOverdue_days_second": "{0} days 1 second overdue",
        "SLATooltipOverdue_days_seconds": "{0} days {1} seconds overdue",
        "SLATooltipOverdue_hour": "1 hour overdue",
        "SLATooltipOverdue_hours": "{0} hours overdue",
        "SLATooltipOverdue_hour_minute": "1 hour 1 minute overdue",
        "SLATooltipOverdue_hour_minutes": "1 hour {0} minutes overdue",
        "SLATooltipOverdue_hours_minute": "{0} hours 1 minute overdue",
        "SLATooltipOverdue_hours_minutes": "{0} hours {1} minutes overdue",
        "SLATooltipOverdue_hour_minute_second": "1 hour 1 minute 1 second overdue",
        "SLATooltipOverdue_hour_minute_seconds": "1 hour 1 minute {0} seconds overdue",
        "SLATooltipOverdue_hour_minutes_second": "1 hour {0} minutes 1 second overdue",
        "SLATooltipOverdue_hour_minutes_seconds": "1 hour {0} minutes {1} seconds overdue",
        "SLATooltipOverdue_hours_minute_second": "{0} hours 1 minute 1 second overdue",
        "SLATooltipOverdue_hours_minute_seconds": "{0} hours 1 minute {1} seconds overdue",
        "SLATooltipOverdue_hours_minutes_second": "{0} hours {1} minutes 1 second overdue",
        "SLATooltipOverdue_hours_minutes_seconds": "{0} hours {1} minutes {2} seconds overdue",
        "SLATooltipOverdue_hour_second": "1 hour 1 second overdue",
        "SLATooltipOverdue_hour_seconds": "1 hour {0} seconds overdue",
        "SLATooltipOverdue_hours_second": "{0} hours 1 second overdue",
        "SLATooltipOverdue_hours_seconds": "{0} hours {1} seconds overdue",
        "SLATooltipOverdue_minute": "1 minute overdue",
        "SLATooltipOverdue_minutes": "{0} minutes overdue",
        "SLATooltipOverdue_minute_second": "1 minute 1 second overdue",
        "SLATooltipOverdue_minute_seconds": "1 minute {0} seconds overdue",
        "SLATooltipOverdue_minutes_second": "{0} minutes 1 second overdue",
        "SLATooltipOverdue_minutes_seconds": "{0} minutes {1} seconds overdue",
        "SLATooltipOverdue_second": "1 second overdue",
        "SLATooltipOverdue_seconds": "{0} seconds overdue",

        "waitTimeTooltip_for": " for ",
        "waitTimeTooltip_after": " after waiting for ",

        "unreadMessages": "Conversation has unread messages.",
        "conversationStatusTooltip": "Status of the conversation.",
        "conversationSkillTooltip" : "The skill assigned to the conversation.",
        "unreadMessagesByAssignedAgent": "{0} unread messages by {1}{2}",
        "transferredToAgent": "Transferred to ",
        "assignedToAgent": "Assigned to ",

        "conversationClosedByManagerNotificationTitle": "Conversation closed",
        "conversationClosedByManagerNotificationText": "Your conversation with '{0}' has been closed and will be available in your closed list.",
        "conversationReturnedToQueueByManagerNotificationTitle": "Conversation returned to queue",
        "conversationReturnedToQueueByManagerNotificationText": "Your conversation with '{0}' has been returned to the queue and will no longer be visible.",

        "STATE_CLOSED_CONVERSATION": "Closed conversation",
        "STATE_CLOSED_CONVERSATION_AGENT": "Conversation closed by agent.",
        "STATE_CLOSED_CONVERSATION_CONSUMER": "Conversation closed by consumer.",
        "STATE_CLOSED_CONVERSATION_TIMEOUT": "Conversation auto closed by the system.",
        "STATE_IN_CONVERSATION": "Open conversation",
        "URGENT_CONVERSATION": "Urgent conversation",
        "FIRST_TIME_CONVERSATION": "First conversation",
        "OVERDUE_CONVERSATION": "Overdue conversation",
        "IN_QUEUE_CONVERSATION" : "Conversation in queue",
        "IN_SURVEY_CONVERSATION" : "closed, in survey",
        "CLOSE_REASON_AGENT": "Agent",
        "CLOSE_REASON_CONSUMER": "Consumer",
        "CLOSE_REASON_TIMEOUT": "Auto",

        "post_survey_dialogStart": "Survey started",
        "post_survey_dialogEnd": "Survey submitted",
        "survey_in_progress": "survey in progress",
        "survey_in_progress_error_content_message": "This message or content can't be sent because a survey is now in progress.",

        "MESSAGE_RECEIVED": "Consumer has received the message.",
        "MESSAGE_READ": "Consumer has read the message.",
        "MESSAGE_SENT": "Message has been sent to the consumer.",
        "MESSAGE_NACK": "Message could not be delivered to consumer.",
        "MESSAGE_VIEWED": "Consumer has open the message.",
        "MESSAGE_ERROR": "An error occurred while the consumer tried to view the message.",

        "structure_content_message_failed": "Error: your message could not be sent.",

        "MY_CONNECTIONS_LIST_table_title": "Open Conversations",
        "MY_CONNECTIONS_LIST_table_description": "All conversations that are currently open and have yet to be resolved.",
        "MY_CONNECTIONS_LIST_empty": "No conversations.",
        "MY_CONNECTIONS_LIST_emptyFiltered": "No matching conversations to display.",
        "MY_CONNECTIONS_LIST_error": "Could not load Open Conversations list, please reload the page.",
        "MY_CONNECTIONS_LIST_TotalItemsSingle" : "You are viewing 1 conversation",
        "MY_CONNECTIONS_LIST_TotalItemsMulti" : "You are viewing {0} conversations",
        "MY_CONNECTIONS_LIST_PartialItems" : "You are viewing {0}-{1} of {2} conversations",

        "APP_CONNECTIONS_LIST_table_title": "Open Conversations",
        "APP_CONNECTIONS_LIST_table_description": "All conversations that are currently open and have yet to be resolved.",
        "APP_CONNECTIONS_LIST_empty": "No conversations.",
        "APP_CONNECTIONS_LIST_emptyFiltered": "No matching conversations to display.",
        "APP_CONNECTIONS_LIST_error": "Could not load Open Conversations list, please reload the page.",
        "APP_CONNECTIONS_LIST_TotalItemsSingle" : "You are viewing 1 conversation",
        "APP_CONNECTIONS_LIST_TotalItemsMulti" : "You are viewing {0} conversations",
        "APP_CONNECTIONS_LIST_PartialItems" : "You are viewing {0}-{1} of {2} conversations",

        "CONNECTIONS_LOG_table_title": "All Conversations",
        "CONNECTIONS_LOG_table_description": "View, sort and search current and past conversations.",
        "CONNECTIONS_LOG_empty": "No conversations.",
        "CONNECTIONS_LOG_emptyFiltered": "No matching conversations to display.",
        "CONNECTIONS_LOG_error": "Could not load All Conversations list, please reload the page.",
        "CONNECTIONS_LOG_TotalItemsSingle" : "You are viewing 1 conversation",
        "CONNECTIONS_LOG_TotalItemsMulti" : "You are viewing {0} conversations",
        "CONNECTIONS_LOG_PartialItems" : "You are viewing {0}-{1} of {2} conversations",
        "CONNECTIONS_LOG_search_caption" : "Filter by keyword:",
        "CONNECTIONS_LOG_search_caption_tooltip" : "Filter by words or phrases present within transcripts and/or surveys.",

        "CONNECTIONS_LOG.chatStartTooltip" : "Time when the consumer first started the conversation, presented in local time.",
        "CONNECTIONS_LOG.conversationStatusTooltip" : "Status of the conversation (open or closed).",
        "CONNECTIONS_LOG.sentimentTooltip" : "Meaningful Conversation Score (MCS). Currently available in English and French.",
        "CONNECTIONS_LOG.csatTooltip" : "Customer satisfaction rated from 1 to 5, as provided by the consumer at the end of the conversation.",
        "CONNECTIONS_LOG.skillTooltip" : "Skill assigned to the conversation.",
        "CONNECTIONS_LOG.pastChatAgentNameTooltip" : "The latest agent who was assigned to the conversation.",
        "CONNECTIONS_LOG.activeChatAgentGroupTooltip" : "The agent group name of the agent that was assigned to the conversation.",
        "CONNECTIONS_LOG.pastChatAgentNameTooltipMultiValue" : "The name of the Agent(s) assigned to the conversation.",
        "CONNECTIONS_LOG.activeChatAgentGroupTooltipMultiValue" : "The Agent Group that the Agent(s) assigned to the conversation belong to.",
        "CONNECTIONS_LOG.lastMessageTimeTooltip" : "Time of the last message in the conversation.",
        "CONNECTIONS_LOG.engLengthTooltip" : "Timeframe from when the consumer started the conversation until it was ended by the agent or the consumer.  For open conversations, duration displayed represents the time from start until the moment this data is viewed.",
        "CONNECTIONS_LOG.conversation_summary" : "search by specific word or phrase that are part of the conversation's summary.",
        "CONNECTIONS_LOG.engagement_attributes" : "search by information passed as attributes within the Engagement Attributes. For example: name, email, customer id etc.",
        "CONNECTIONS_LOG.surveyNameIdTooltip" : "The survey Name or its ID.",
        "CONNECTIONS_LOG.npsTooltip" : "Customer Net Promoter Score rated from 0 to 10, as submitted by the customer within the survey.",
        "CONNECTIONS_LOG.fcrTooltip" : "Customer First Call Resolution as submitted by the customer within the survey.",
        "CONNECTIONS_LOG.freeTextAnswerTooltip" : "Filter by specific words or phrases.",
        "CONNECTIONS_LOG.csatPCSTooltip" : "Customer satisfaction rated from 1 to 5, as submitted by the customer within the survey.",
        "CONNECTIONS_LOG.pendingAgentSurveyTooltip" : "Search by messaging agent survey state.",

        "CONNECTIONS_LOG_disable_filter_tooltip": "Filters cannot be applied when search by conversation ID is enabled",

        "CONNECTIONS_LOG_action_allConnectionsSearchOnToken": "Generate token",
        "CONNECTIONS_LOG_action_allConnectionsSearchOnTokenTooltip": "Generate a secure form token to enable you to search for the form in conversations.",

        "generateTokenTitle": "Token Generation",
        "copyToken": "Copy token",
        "generateTokenFailedTitle": "Something went wrong",
        "generateTokenFailedMessage": "Failed to generate a token, please try again.",
        "generateTokenPciCompliantFailedMessage": "Token could not be generated - Secure Form is not available.",
        "tryAgain": "Try again",

        "MESSAGING_AGENT_LIST_table_title" : "Messaging Agents",
        "MESSAGING_AGENT_LIST_table_description" : "List of logged in messaging agents, including information on their availability, conversation KPIs and performance.",
        "MESSAGING_AGENT_LIST_empty": "No agents.",
        "MESSAGING_AGENT_LIST_emptyFiltered": "No matching agents to display.",
        "MESSAGING_AGENT_LIST_error": "Could not load agents list, please reload the page.",
        "MESSAGING_AGENT_LIST_TotalItemsSingle" : "You are viewing 1 agent",
        "MESSAGING_AGENT_LIST_TotalItemsMulti" : "You are viewing {0} agents",
        "MESSAGING_AGENT_LIST_PartialItems" : "You are viewing {0}-{1} of {2} agents",

        "MESSAGING_AGENT_LIST_table_column_status_tooltip" : "State",
        "MESSAGING_AGENT_LIST_table_column_agentName" : "AGENT NAME",
        "MESSAGING_AGENT_LIST_table_column_agentName_tooltip" : "Agent name",
        "MESSAGING_AGENT_LIST_table_column_agent_group" : "AGENT GROUP",
        "MESSAGING_AGENT_LIST_table_column_agent_group_tooltip" : "The group the agent is assigned to.",
        "MESSAGING_AGENT_LIST_table_column_skills" : "SKILLS",
        "MESSAGING_AGENT_LIST_table_column_skills_tooltip" : "The Skill(s) assigned to the agent.",
        "MESSAGING_AGENT_LIST_table_column_concurrent" : "OPEN",
        "MESSAGING_AGENT_LIST_table_column_concurrent_tooltip" : "The number of open conversations being handled by the agent.",
        "MESSAGING_AGENT_LIST_table_column_maxConcurrent" : "MAX. OPEN",
        "MESSAGING_AGENT_LIST_table_column_maxConcurrent_tooltip" : "The configured max. number of high intensity conversations.",
        "MESSAGING_AGENT_LIST_table_column_load" : "LOAD",
        "MESSAGING_AGENT_LIST_table_column_load_tooltip" : "Total weight of the assigned conversations divided by the agent’s configured max. number of high intensity conversations.",
        "MESSAGING_AGENT_LIST_table_column_active" : "ACTIVE",
        "MESSAGING_AGENT_LIST_table_column_active_tooltip" : "Number of conversations at full intensity.",
        "MESSAGING_AGENT_LIST_table_column_stateDuration" : "STATE DURATION",
        "MESSAGING_AGENT_LIST_table_column_stateDuration_tooltip" : "Time since the agent changed their state, and where applicable, the specific reason.",
        "MESSAGING_AGENT_LIST_table_column_onlineRate" : "% ONLINE",
        "MESSAGING_AGENT_LIST_table_column_onlineRate_tooltip" : "The % of time the agent has spent in the Online state out of their total logged in time over the last 12 hours.",
        "MESSAGING_AGENT_LIST_table_column_closedConversations" : "CLOSED",
        "MESSAGING_AGENT_LIST_table_column_closedConversations_tooltip" : "Number of conversations owned by the agent that were resolved in the last 12 hours (closed automatically, or by the agent or consumer).",

        "conversationTransferTimeText": "Conversation transferred: ",
        "conversationEndTimeText": "Conversation closed",
        "openConversation": "Open conversation",

        "isConversationResolvedTitle": "Resolved",
        "isConversationResolvedText_true": "Yes",
        "isConversationResolvedText_false": "No",
        "isConversationResolvedTooltip_true": "The consumer marked this conversation as resolved",
        "isConversationResolvedTooltip_false": "The consumer marked this conversation as unresolved",

        // ---------------------------------------------------

        "loading": "Loading",
        "transferEngagementTitle": "Transfer engagement",
        "transferConversationTitle": "Transfer conversation",
        "all": "All",
        "byAgent": "Agent",
        "bySkill": "Skill",
        "byAccount": "Account",
        "skills": "Skills",
        "overloadedAgent": "Overloaded",
        "agentUnavailable": "Agent not available",
        "visitor_name": "Visitor name",
        "transferEngagementTo": "Transferring the engagement to ",
        "loadingAgentsAndSkills": "Retrieving agents and skills from the server. Please wait...",
        "closingTheEngagement": "Engagement transferred successfully,<br/>Closing the engagement...",
        "transferFailedToRetrieveData": "Could not retrieve the transfer data.<br/><br/>Please try again.",
        "backToList": "Back to list",
        "transfer": "Transfer",
        "next": "Next",
        "toAgent": "To agent",
        "toSkill": "To skill",
        "currentConversationSkill": "current conversation skill",
        "transferConversation": "Transfer conversation",
        "transferErrorTargetUnavailable": "Could not transfer. It is possible that <span class=\"lpview_agent_to_transfer_name bold_name\">{0}</span> is not available anymore.",
        "transferWillCloseMessage": "This will close the engagement in the Visitor engagement area.",
        "transferWillCloseConversation": "This will remove the conversation from your view.",
        "noteTitle": "Note:",
        "search": "Search",
        "onlineAgents": "Online agents",
        "loggedInAgents" : "Logged in agents",
        "transfer_by_skill_no_wait_time": "Expected wait time cannot be determined at the moment",
        "transfer_by_skill_expected_wait_time": "Expected wait time: {0}",
        "disconnectedEngagementError": "You have been disconnected by the server. A user with your login name just logged into the system.",
        "concurrentAgentReachedError": "Unable to log in to the Visitor engagement area, maximum concurrent users reached.",
        "unableToLogInError": "Unable to connect to the Visitor engagement area.",
        "unableToLogInTitle": "Unable to connect",
        "agentStatusDiscrepancyErrorTitle": "Operation failed",
        "agentStatusDiscrepancyErrorDescription": "Status could not be updated. Please try again",
        "agentStatusChangeFailed": "Operation failed - status could not be updated",
        "loginErrorMessage" : "",

        "transferToAgentConversationNotificationTitle": "Conversation was transferred",
        "transferToAgentConversationNotificationMessage": "Your conversation with {0} has been transferred to {1} and will no longer be visible.",

        "transferToAgent.join.disabled": "You cannot join this conversation because it is already waiting in your queue",

        "transferToAgent.error.agentNoSkill": "The destination agent is no longer assigned the destination skill.",
        "transferToAgent.error.agentNotInConversation": "The transferring agent must a be an assigned agent or joined participant in the conversation.",
        "transferToAgent.error.noSuchAgent": "The destination agent does not exist.",
        "transferToAgent.error.userMissingPrivilleges": "User does not have permissions to execute transfer to agent.",
        "transferToAgent.error.closedConversation": "Conversation has been closed.",
        "transferToAgent.error.closedDialog": "Conversation has been closed.",
        "transferToAgent.error.noAssignedAgent": "There is no assigned agent on the conversation.",
        "transferToAgent.error.disabledFeature": "Transfer to agent feature has not been enabled.",
        "transferToAgent.error.noSuchSkill": "The destination skill does not exist.",
        "transferToAgent.error.unauthorizedUser": "Unauthorized user.",
        "transferToAgent.error.consumerMissingPrivilleges": "Consumer not allowed to transfer conversation.",
        "transferToAgent.error.default": "Operation failed. Please try again.",

        "noAgentsFound": "There are no available agents for transfer.",
        "noSkillsFound": "There are no available skills for transfer.",
        "noAccountFound": "There are no available accounts for transfer.",
        "help": "Help",

        "contentSanitized": "To minimize interference with your workflow, elements were removed from the content you sent. The content will be displayed to the visitor according to your website administrator policy.",
        "contentSanitizedPrivateMessage": "To minimize interference with your workflow, elements were removed from the content you sent.",
        "contentTooLong": "Your message contained too many characters and could not be sent.",
        "sendLineError": "Could not send the message. Check your content and try again.",
        "systemMessageSource": "System",

        "VisitorInfoWidget": "Visitor information",
        "PCIDataWidget": "PCI Data",
        "AgentSurveyWidget": "Agent survey",
        "AgentSurveyMessagingWidget": "Agent survey",
        "AgentSummaryWidget": "Summary",
        "PreDefinedWidget": "Predefined content",
        "ChatHistoryWidget": "Conversation history",
        "EngagementWidget": "Chat",
        "PageNavigationWidget": "Page navigation",
        "VisitorListEngagementWidget" : "Chat",
        "MyConnectionsEngagementWidget" : "Conversation",
        "AppConnectionsEngagementWidget" : "Conversation",
        "ConnectionsLogEngagementWidget" : "Conversation",
        "EngagementsHistoryEngagementWidget" : "Chat",
        "OperatorAlertsWidget": "Alerts",
        "VisitInfoWidget": "Visit info",
        "ConsumerInfoWidget": "Consumer info",
        "AIAssistWidget": "Recommended actions",
        "csatRate": "CSAT",
        "EngagementsHistoryVisitInfoWidget": "Visit info",
        "transcript": "Transcript",
        "visitorInfo": "Visitor information",
        "pageHasNoTitle": "(Page has no title)",
        "sectionsLabel": "Sections:",

        "paging_start_tooltip": "Start",
        "paging_prev_tooltip": "Prev",
        "paging_next_tooltip": "Next",
        "paging_end_tooltip": "End",

        "OperatorAlertsDescription": "Description",
        "OperatorAlertsTime": "Time fired",

        "noTitle": "No title",
        "endEngagementTitle": "You are about to end the engagement with the visitor:",
        "endEngagementDescription": "Your engagement will move to the Closed list. You will still be able to edit the visitor's information.",
        "cancel": "Cancel",
        "ok": "OK",
        "confirm": "Confirm",
        "reconnect": "Reconnect",
        "endEngagement": "End engagement",
        "unableToDisplayChatTranscript": "Unable to display the chat transcript.",
        "AreYouSure" : "Are you sure?",
        "StatusChange" : "Status change",
        "StatusChangeText" : "Please notice that your status has been changed to Away.",

        "signoutTitle": "Are you sure you want to log out?",
        "signoutDescription": "Active chats will be moved to the skill queue and all closed chats will no longer be available.",
        "signoutWarning": "You are currently logged into an active agent session. If you have active chats, they will be transferred to other agents. Your closed chats will no longer be available.",
        "signoutWarningAsyncMessaging": "Active Agent session (you are currently logged in as an agent).",

        "connectionProblems": "Connection issues",
        "connectionProblemsDescription": "We are experiencing connection issues, please be patient while the Visitor engagement area reconnects...",
        "pleaseWait": "Please wait while the Conversational Cloud attempts to reconnect.",
        "connectionProblemQueueOrbTooltip": "The Conversational Cloud is currently reconnecting, you will temporarily be unable to receive new chats.",
        "connectionProblemSendLineTooltip": "The Conversational Cloud is reconnecting, you cannot currently send messages.",
        "connectionProblemDropdownMenuTooltip": "The Conversational Cloud is currently reconnecting, the action menu has been temporarily disabled.",

        "waitingForConversations": "Waiting for conversations...",
        "noRecommendedContent": "No content to display",
        "noDataToDisplay": "No content to display",
        "navigateAwayWarning": "Active agent session (you are currently logged in as an agent).",

        "hotkeysTitle": "Hotkeys",
        "hotkeysDescription": "(Ctrl + `)",
        "quickContentTitle": "Quick content",

        "hotkeyDescriptionAcceptNextChat": "Accept engagement",
        "hotkeyDescriptionStatusWidget": "Status (toggle)",
        "hotkeyDescriptionFocusNavigationBack": "Previous engagement",
        "hotkeyDescriptionFocusNavigationForward": "Next engagement",
        "hotkeyDescriptionCloseEngagement": "End/close engagement",
        "hotkeyDescriptionTransferEngagement": "Transfer engagement",
        "hotkeyDescriptionTransferConversation": "Transfer conversation",
        "hotkeyDescriptionSignout": "Logout",
        "hotkeyDescriptionClosedList": "Closed list",
        "hotkeyDescriptionInactiveList": "Closed list",
        "hotkeyDescriptionStatusToAway": "Change state to Away",
        "hotkeyDescriptionStatusToOnline": "Change state to Online",
        "hotkeyDescriptionStatusToOccupied": "Change state to Back Soon",
        "hotkeyDescriptionNextToTakeAction": "Next engagement response",
        "hotkeyDescriptionNextActiveEngagement": "Next active engagement",
        "hotkeyDescriptionPrevActiveEngagement": "Previous active engagement",
        "hotkeyDescriptionVisitorList": "Visitor list",
        "hotkeyDescriptionVisitorTables": "Visitor tables",
        "hotkeyDescriptionAcceptConversation": "Accept conversation",
        "hotkeyDescriptionRespondToNext": "Respond to next",
        "hotkeyDescriptionHideConversation": "Hide conversation",
        "hotkeyDescriptionCloseConversation": "Close conversation",
        "hotkeyDescriptionMyConnectionsList": "Open Conversations list",
        "hotkeyDescriptionAppConnectionsList": "Open Conversations list",
        "hotkeyDescriptionReturnToQueue": "Return conversation to queue",
        "hotkeyDescriptionListView": "List view",

        "hotkeyDescriptionSignoutTooltip": "Log out of your account.",
        "hotkeyDescriptionHideConversationTooltip": "Hide the conversation so that it runs in the background and can be resumed later.",
        "hotkeyMyConnectionsListTooltip": "Navigate to Open Conversations list.",
        "hotkeyAppConnectionsListTooltip": "Navigate to Open Conversations list.",
        "hotkeyClosedListTooltip": "Navigate to Closed list.",
        "hotkeyListViewTooltip": "Navigate to list view.",
        "hotkeyDescriptionAcceptConversationTooltip": "Accept an incoming conversation.",
        "hotkeyDescriptionReturnToQueueTooltip": "Return the current conversation to the queue.",
        "hotkeyDescriptionCloseConversationTooltip": "Mark the conversation as closed.",

        "alt": "Alt",
        "ctrl": "Ctrl",
        "shift": "Shift",
        "ctrlAlt": "Alt+Ctrl",
        "ctrlShift": "Ctrl+Shift",
        "altShift": "Alt+Shift",
        "ctrlAltShift": "Alt+Ctrl+Shift",

        "alphaReleaseNotesLink": "Update notes",
        "alphaNote": "This is an Alpha application and does not include all functionality available in other LivePerson consoles.",

        "loadWidgetURL": "Enter the URL for the widget to load.",
        "loadWidgetTitle": "Load widget",

        "visitorState": "STATE",
        "visitorName": "VISITOR NAME",
        "audience": "AUDIENCE",
        "from": "COUNTRY",
        "from_neutral": "COUNTRY/REGION",
        "organization": "ORGANIZATION",
        "skill": "SKILL",
        "searchKeywords": "KEYWORDS",
        "currentPage": "CURRENT PAGE",
        "device": "DEVICE",
        "deviceFamily": "DEVICE",
        "ip": "IP",
        "numOfViewedPages": "PAGES",
        "browser": "BROWSER",
        "visitStartTime": "VISIT START",
        "activeChatAgentName": "AGENT NICKNAME",
        "activeChatAgentGroup": "AGENT GROUP",
        "pastChatAgentName" : "AGENT NAME",
        "chatStart" : "START",
        "chatTransferEndBorder": "Chat transferred",
        "chatTransferStartBorder": "Start chat with",
        "splitSessionSeparator": "You are now resuming your chat with",
        "engLength" : "LENGTH",
        "duration" : "DURATION",
        "interactiveChat" : "INTERACTIVE",
        "status": "STATUS",
        "conversationStatus": "STATUS",
        "startPage": "START PAGE",
        "MCS": "MCS",
        "chatDuration": "CHAT DURATION",
        "agentType": "AGENT TYPE",
        "agentTypeVisitors":"Agent type",
        "filterByAgentType": "Filter by agent type",
        "filterByAgentsType": "Filter by Agent type",
        "filterByBrowser": "Filter by Browser",
        "filterByDate": "Filter by Date",
        "filterByDuration": "Filter by Duration",
        "filterByResponseTime": "Filter by Response Time",
        "filterByStatus": "Filter by Status",
        "filterByAgentGroup": "Filter by Agent Group",
        "agentTypeHuman": "Human",
        "agentTypeBot": "Bot",
        "filterByAgent": "Filter By Agent",
        "filterBySkill": "Filter By Skill",
        "filterTitleVisitors": "Agent nickname",
        "infoTitle": "INFO",




        "infoTitleTooltip": "Visit information",
        "infoColumnTooltip": "Info",
        "visitorStateTooltip": "Indicates the status of the visitor.",
        "sentimentTooltip" : "Meaningful Conversation Score (MCS). Currently available in English and French.",
        "visitorNameTooltip": "Visitor name from the pre-chat survey.",
        "audienceTooltip": "AUDIENCE",
        "fromTooltip": "Visitor is browsing from the country indicated.",
        "fromTooltip_neutral": "Visitor is browsing from the country/region indicated.",
        "organizationTooltip": "ORGANIZATION",
        "skillTooltip": "Skill assigned to the engagement.",
        "activeChatAgentTypeTooltip": "Agent type assigned to the engagement.",
        "nonValidSkillTooltip" : "The skill is no longer active.",
        "searchKeywordsTooltip": "KEYWORDS",
        "currentPageTooltip": "Visitor is browsing the indicated web page.",
        "deviceTooltip": "Device customer was using while chatting.",
        "ipTooltip": "IP",
        "numOfViewedPagesTooltip": "Number of pages that the visitor has visited during this session.",
        "browserTooltip": "BROWSER",
        "browsersTooltip": "Browser assigned to the engagement.",
        "deviceFamilyTooltip": "Device Family",
        "visitStartTimeTooltip": "Time when the visitor began the session.",
        "activeChatAgentNameTooltip": "The agent nickname will appear here when an agent has been assigned.",
        "activeChatAgentGroupTooltip": "The agent group name will appear here when an agent has been assigned.",
        "pastChatAgentNameTooltip": "The agent who handled the chat.",
        "nonValidAgentNameTooltip" : "The skill is no longer active.",
        "chatStartTooltip" : "Time when the visitor was first connected to the agent. Time is presented in local time.",
        "engLengthTooltip" : "Time from when the visitor is connected to the agent until the Engagement Window is closed.",
        "interactiveChatTooltip" : "An engagement becomes interactive when the visitor enters text.",
        "startPageTooltip": "The first page of the chat",
        "chatDurationTooltip": "Duration of the chat",
        "statusInChat": "In chat",
        "statusViewedContent": "Viewed content",
        "contentDeclined": "Content declined",
        "waitingForChat": "Waiting for chat",
        "chatEnded": "Chat ended",



        "selectValueBelow": "Select value",
        "actions": "Actions",
        "visitorList": "Visitor list",
        "visitorListDescription": "Your website visitors in real time, including information on who they are and their digital journey.",
        "inviteToChat": "Invite to chat",
        "block": "Block",
        "visitorListEmpty": "No visitors on website.",
        "visitorListError": "Could not load the Visitor list, please reload the page.",
        "visitorListTotalVisitorsSingle" : "1 visitor on your website",
        "visitorListTotalVisitorsMulti" : "{0} visitors on your website",
        "visitorListShowingVisitors" : "Showing {0}-{1} of {2} visitors on your website",

        "VISITOR_LIST_table_title": "Web Visitors",
        "VISITOR_LIST_table_description": "Your workspace for live conversations with consumers through web and mobile sites. View all current conversations along with real time visitors.",
        "VISITOR_LIST_empty": "No visitors on website.",
        "VISITOR_LIST_emptyFiltered": "No matching visitors to display.",
        "VISITOR_LIST_emptyStart2End": "You have reached the end of the Visitors list.",
        "VISITOR_LIST_error": "Could not load the Visitor list, please reload the page.",
        "VISITOR_LIST_TotalItemsSingle" : "1 visitor on your website",
        "VISITOR_LIST_TotalItemsMulti" : "{0} visitors on your website",
        "VISITOR_LIST_PartialItems" : "Showing {0}-{1} of {2} visitors on your website",
        "VISITOR_LIST_PreFiltering_TotalItemsSingle" : "There is a total of 1 visitor on your website",
        "VISITOR_LIST_PreFiltering_TotalItemsMulti" : "There are a total of {0} visitors on your website.",

        "ENGAGEMENTS_HISTORY_table_title": "Web History",
        "ENGAGEMENTS_HISTORY_table_description": "View, search and sort your web chat history, including information about transcripts and surveys.",
        "ENGAGEMENTS_HISTORY_empty": "No matching engagements to display.",
        "ENGAGEMENTS_HISTORY_emptyFiltered": "No matching engagements to display.",
        "ENGAGEMENTS_HISTORY_error": "There was a problem loading your data. Please refresh.",
        "ENGAGEMENTS_HISTORY_TotalItemsSingle" : "1 engagement",
        "ENGAGEMENTS_HISTORY_TotalItemsMulti" : "{0} engagements",
        "ENGAGEMENTS_HISTORY_PartialItems" : "Showing {0}-{1} of {2} engagements",
        "ENGAGEMENTS_HISTORY_search_caption" : "Filter by keyword:",
        "ENGAGEMENTS_HISTORY_search_caption_tooltip" : "Filter by words or phrases present within transcripts and/or surveys.",
        "ENGAGEMENTS_HISTORY_action_webHistoryExportToCsv" : "Export to CSV",
        "ENGAGEMENTS_HISTORY_action_webHistoryExportToCsv_tooltip" : "This will export the results of your filter/search to a CSV file.",
        "ENGAGEMENTS_HISTORY_action_webHistoryExportToJson" : "Export to JSON",
        "ENGAGEMENTS_HISTORY_action_webHistoryExportToJson_tooltip" : "This will export the results of your filter/search as JSON.",
        "ENGAGEMENTS_HISTORY_action_tooltip_too_many_records" : "Too many records to export. Narrow down your search to less than 100,000 transcripts, or use the Web History API to export all items.",
        "ENGAGEMENTS_HISTORY_notify_export_start": "Exporting web history",
        "ENGAGEMENTS_HISTORY_notify_export_error": "Export failed. Please try again.",
        "ENGAGEMENTS_HISTORY_disable_filter_tooltip": "Filters cannot be applied when search by engagement ID is enabled",


        "history_search_filter_transcript" : "Transcript Line",
        "history_search_filter_surveys" : "Surveys",
        "history_search_filter_SDEs" : "Engagement Attributes",
        "history_search_filter_chat_ID" : "Engagement ID",
        "history_search_filter_transcripts" : "Transcripts",
        "history_search_filter_conversation_ID" : "Conversation ID",
        "history_search_filter_visitor_info" : "Visitor Info",
        "history_search_filter_response_time": "Response time",
        "history_search_filter_summary": "Summary",
        "filter_after_title_separator": ":",
        "history_search_filter_conversation_summary": "Conversation summary",
        "history_search_filter_engagement_attributes": "Engagement attributes",

        "AGENT_LIST_table_title": "Agents",
        "AGENT_LIST_table_title_all": "All Agents",
        "AGENT_LIST_table_description": "List of online agents in real-time, including information about their availability and capacity.",
        "AGENT_LIST_empty": "There are no agents online. Filter the agent status to see agents who are logged in.",
        "AGENT_LIST_emptyFiltered": "No agents to display.",
        "AGENT_LIST_error": "There was a problem loading your data. Please refresh.",
        "AGENT_LIST_table_column_elapsedTimeInState": "STATE DURATION",
        "AGENT_LIST_table_column_agentName": "AGENT NAME",
        "AGENT_LIST_table_column_skills": "SKILLS",
        "AGENT_LIST_table_column_concurrent": "CURRENT CHATS",
        "AGENT_LIST_table_column_maxConcurrent": "MAX CONCURRENCY",
        "AGENT_LIST_table_column_status_tooltip": "State",
        "AGENT_LIST_table_column_elapsedTimeInState_tooltip": "Time elapsed since Agent entered current state",
        "AGENT_LIST_table_column_agentName_tooltip": "The agent name.<br/>Max. display: 100 agents.",
        "AGENT_LIST_table_column_skills_tooltip": "Skill(s) assigned to the agent.",
        "AGENT_LIST_table_column_concurrent_tooltip": "Number of current chats that are being handled by the agent.",
        "AGENT_LIST_table_column_maxConcurrent_tooltip": "Maximum concurrent chats that the agent can handle.",
        "AGENT_LIST_filter_skills_title": "Skills",
        "AGENT_LIST_nickname": "Nickname",
        "AGENT_LIST_unlimited": "Unlimited",
        "AGENT_LIST_TotalItemsSingle" : "You are viewing 1 agent",
        "AGENT_LIST_TotalItemsMulti" : "You are viewing {0} agents",
        "AGENT_LIST_PartialItems" : "You are viewing {0}-{1} of {2} agents",
        "AGENT_LIST_elapsed_time_status_tooltip": "Agent has been in this status for: ",
        "STATE_NONE": "Visitor is not on the website",
        "STATE_IN_SITE": "Visitor is visiting the website",
        "STATE_IN_CHAT": "Visitor is participating in a chat",
        "STATE_NO_CHAT": "Visitor has declined to chat",
        "STATE_WAITING_FOR_CHAT": "Visitor is waiting to chat",
        "STATE_CHAT_REFUSED": "Agent has declined to chat",
        "STATE_AFTER_CHAT": "Chat has ended",
        "STATE_OFFLINE_IMPRESSION" : "Visitor exposed to offline chat",
        "STATE_REP_WANTS_TO_CHAT": "Visitor was invited to chat",
        "STATE_LEFT_SITE": "Visitor has left the website",
        "STATE_REP_PUSH_CHAT": "Agent has manually engaged a visitor with a chat",
        "STATE_SAVED": "Saved",
        "STATE_INTERNAL": "Internal",
        // STATE_NONE: "No Voice",
        "STATE_VISITOR_WANTS_TO_VOICE": "Visitor requests callback",
        "STATE_WAITING_FOR_ANSWER": "Waiting for answer",
        "STATE_CONNECTING": "Connecting",
        "STATE_IN_CALL": "In call",
        "STATE_DONE": "Disconnected",
        "STATE_ERROR": "Could not start call",
        "STATE_CONNECTING_REMOTE": "Connecting remote",
        "STATE_IN_CALL_REMOTE": "In call remote",
        "STATE_REP_WANTS_TO_VOICE": "Agent requests callback",
        "STATE_REP_TO_REP": "Agent to agent",
        "STATE_NO_CALL": "Visitor refused callback",
        "STATE_WAITING_RETRY": "Waiting to retry",
        "STATE_IVR": "IVR",
        "STATE_SCHEDULED_CALLBACK": "Scheduled callback",
        "STATE_SCHEDULED_CALLBACK_FAILURE": "Scheduled callback error",

        "joinConversation": "Join conversation",
        "resumeConnection": "Resume connection",
        "lostConnectionTitle": "Connection lost",
        "lostConnectionDescription": "Connection lost to the server, reconnecting...",
        "close": "Close",
        "agentSessionTimedOutTitle": "Agent session timed out",
        "agentSessionTimedOutDescription": "Your session timed out. Click OK to reconnect.",
        "to": "To:",
        "agentName" : "Agent name",
        "addComment" : "Add comment",
        "privateMessage" : "Private message",
        "privateMessageDescription" : "Only agents can see this message.",
        "openEngagement" : "Open engagement",
        "send" : "Send",
        "unformatted_text_copyToClipboard": "Copy as plain text",
        "unformatted_text_selectAll": "Select all text",
        "unformatted_text_selectAllTooltip": "After clicking on this button, use your keyboard or mouse to copy and paste the text.",
        "try_joining_again_text": "Try joining again",
        "failed_to_join_conversation_error_text": "Failed to join conversation. please try again.",

        "CHATINPUT_disabledOldConverasation": "The conversation has been closed for {0} days and can not be resumed",

        "newChatReceivedTooltip" : "New chat received!",
        "newConversationReceivedTooltip" : "New conversation received!",

        "maxChatsReached" : "Chat limit reached",

        "filter_button_filter": "Filter",
        "filter_button_reset": "Reset",
        "filter_button_set": "Set",

        "filter_duration_title_sla_is": "Response time is",
        "filter_duration_length": "Length is",
        "filter_duration_longer": "Longer than",
        "filter_duration_shorter": "Shorter than",
        "filter_duration_between": "Between",
        "filter_duration_minutes": "minutes",
        "filter_duration_and": "and",


        "filter_duration_unit_seconds": "Seconds",
        "filter_duration_unit_minutes": "Minutes",
        "filter_duration_unit_hours": "Hours",
        "filter_duration_unit_days": "Days",

        "filter_timeFrame_now": "Now",

        "filter_title_isAgentSurvey": "Agent survey",
        "filter_true_button_isAgentSurvey": "Yes",
        "filter_false_button_isAgentSurvey": "No",

        "filter_title_isInteractive": "Interactive chat",
        "filter_true_button_isInteractive": "Yes",
        "filter_false_button_isInteractive": "No",

        "filter_title_country": "Filter By Country",
        "filter_title_skill": "Skill",
        "filter_title_skills": "Skills",
        "filter_title_agents": "Agent names",
        "filter_deleted_agents_title": "Include deleted agents",
        "filter_deleted_indication": "Deleted",
        "filter_title_agentGroups": "Agent groups",
        "filter_title_device": "Device",
        "filter_title_devices": "Filter by Devices",
        "filter_title_mcs": "MCS",
        "filter_title_mcss": "filter by MCS",
        "filter_title_status": "Status",
        "filter_title_source": "Source",
        "filter_title_selectSurvey": "Select survey",
        "filter_title_country_placeholder": "countries",

        "chat_duration_tooltip": "Time from when the visitor is connected to the agent until the Engagement Window is closed",

        "filter_time_frame_from": "From",
        "filter_time_frame_to": "To",

        "filter_title_agentStatus": "Agent status:",
        "filter_online_agentStatus": "Online",
        "filter_back_soon_agentStatus": "Back Soon",
        "filter_away_agentStatus": "Away",

        "filter_status_title_show_status" : "Show status",

        "filter_mcs_positive": "Positive",
        "filter_mcs_negative": "Negative",
        "filter_mcs_from": "From",
        "filter_mcs_to": "To",

        "predefined_error": "Could not load the recommended content.",
        "predefined_errorMessage": "Could not load the Predefined Content.",
        "predefined_error_refresh": "Refresh",

        "custom_widget_errorMessage": "Widget could not load.",
        "custom_widget_errorMessage_url_too_long": "Widget failed to load, the url is too long.",
        "custom_widget_errorMessage_fail_to_get_data": "Widget failed to load, failed to load visitor data.",
        "custom_widget_errorInfoLink": "Learn more about possible reasons",
        "custom_widget_errorFallbackTextBeforeLink": "Are you logged into the application?",
        "custom_widget_errorFallbackLink": "Click here,",
        "custom_widget_errorFallbackTextAfterLink": " and then refresh the widget.",

        "pilot_mode": "Manager View",
        "custom_widget_refresh_button": "Reloading the widget with the updated parameters.",

        "SENTIMENT_positive": "Chat with positive MCS.",
        "SENTIMENT_negative": "Chat with negative MCS.",
        "SENTIMENT_neutral": "Chat with neutral MCS.",

        "engagement_sentiment_tooltip_positive": "Positive MCS has been detected in this conversation.",
        "engagement_sentiment_tooltip_negative": "Negative MCS has been detected in this conversation.",
        "engagement_sentiment_message": "Negative MCS has been detected in this conversation.",
        "engagement_failed_messages": "{0} of your messages failed to send.",
        "engagement_failed_messages_resend": "Click to resend",

        "operatorAlerts_errorMessage" : "Could not load the alerts.",

        "VISIT_INFO_errorMessage" : "Could not load the visit info.",
        "VISIT_INFO_campaignInfo": "Campaign info",
        "VISIT_INFO_goal": "Goal",
        "VISIT_INFO_goalDescription": "Goal description",
        "VISIT_INFO_goalTooltip": "The goal defined for the campaign from which the conversation was initiated. A campaign's performance is measured by how many visitors reach the defined goal. This enables the success of the campaign to be measured.",
        "VISIT_INFO_campaignName": "Campaign",
        "VISIT_INFO_campaignDescription": "Campaign description",
        "VISIT_INFO_campaignNameTooltip": "The campaign from which the conversation was initiated.",
        "VISIT_INFO_chatSkill": "Chat skill",
        "VISIT_INFO_engagementSkill": "Engagement skill",
        "VISIT_INFO_engagementSkillTooltip": "The skill defined on the engagement from which the conversation was initiated.",
        "VISIT_INFO_targetAudience": "Target audience",
        "VISIT_INFO_targetAudienceDescription": "Target audience description",
        "VISIT_INFO_targetAudienceTooltip": "The target audience configured for the campaign from which the conversation was initiated. The target audience is used to define the attributes of visitors who are targeted as part of the campaign.For example, visitors from a certain geographic location who typed specific search terms to get to the website.",
        "VISIT_INFO_behavior": "Behavior",
        "VISIT_INFO_behaviorDescription": "Behavior description",
        "VISIT_INFO_behaviorTooltip": "The behavior configured for the engagement from which the conversation was initiated. Behaviors are used to define when to display engagements to visitors throughout their digital journey. For example, when a visitor is abandoning their shopping cart.",
        "VISIT_INFO_lob": "Line of business",
        "VISIT_INFO_lobDescription": "Line of business description",
        "VISIT_INFO_lobTooltip": "The line of business defined on the campaign from which the conversation was initiated. Lines of business indicate the matching business division or unit.",
        "VISIT_INFO_engagementType": "Engagement type",
        "VISIT_INFO_agentNote": "Agent note",
        "VISIT_INFO_agentNoteTooltip": "Note to agents as entered on the settings for the engagement from which the conversation was initiated.",
        "VISIT_INFO_source": "Source",
        "VISIT_INFO_sourceDescription": "Where the consumer came from.",
        "VISIT_INFO_sourceTooltip": "The source configured for the engagement from which the conversation was initiated.",
        "VISIT_INFO_employeeId": "Employee ID",
        "VISIT_INFO_engagementName": "Engagement name",
        "VISIT_INFO_engagementNameTooltip": "The engagement from which the conversation was initiated.",

        //these values come from the same enum as "engagementGallery.source" in campaigns
        "VISIT_INFO_offsite_WEB_SITE": "Website",
        "VISIT_INFO_offsite_SOCIAL_MEDIA": "Social media",
        "VISIT_INFO_offsite_EMAIL": "Email",
        "VISIT_INFO_offsite_DIGITAL_ADVERTISING": "Digital advertising",
        "VISIT_INFO_offsite_PRINT": "Print",
        "VISIT_INFO_offsite_TV": "TV",
        "VISIT_INFO_offsite_IVR": "IVR",
        "VISIT_INFO_offsite_OTHER": "Other",
        "VISIT_INFO_offsite_EXTERNAL": "API",

        "VISIT_INFO_ENGAGEMENT_INFO": "Engagement info",
        "VISIT_INFO_ENGAGEMENT_ID": "ID",

        "VISIT_INFO_visitorInfo": "Visitor info",
        "VISIT_INFO_visitorName": "Visitor name",
        "VISIT_INFO_waitTime": "Wait time",
        "VISIT_INFO_sessionId": "Session ID",
        "VISIT_INFO_country": "Country",
        "VISIT_INFO_country_neutral": "Country/Region",
        "VISIT_INFO_countryCode": "Country code",
        "VISIT_INFO_geoState": "Geo state",
        "VISIT_INFO_city": "City",
        "VISIT_INFO_isp": "ISP",
        "VISIT_INFO_organization": "Organization",
        "VISIT_INFO_operatingSystem": "Operating System",
        "VISIT_INFO_browser": "Browser",
        "VISIT_INFO_chatState": "Chat state",
        "VISIT_INFO_referrer": "Referrer",
        "VISIT_INFO_sso": "SSO",
        "VISIT_INFO_mobileDevice": "Device",
        "VISIT_INFO_Device_DESKTOP": "Desktop",
        "VISIT_INFO_Device_TABLET": "Tablet",
        "VISIT_INFO_Device_MOBILE": "Smartphone",
        "VISIT_INFO_Device_NO_DEVICE": "Device not available",
        "VISIT_INFO_mcs_positive": "Positive",
        "VISIT_INFO_mcs_negative": "Negative",

        "VISIT_INFO_ipAddress": "IP Address",

        "VISIT_INFO_chatInfo": "Chat info",
        "VISIT_INFO_rtSessionId": "Real time session ID",
        "VISIT_INFO_accountId": "Account ID",
        "VISIT_INFO_agentName": "Agent name",
        "VISIT_INFO_agentId": "Agent ID",
        "VISIT_INFO_agentNickname": "Agent nickname",
        "VISIT_INFO_chatRequestedTime": "Chat requested time",
        "VISIT_INFO_chatStartTime": "Chat start time",
        "VISIT_INFO_spectatedEngagement": "Spectated engagement",

        "VISIT_INFO_searchEngine": "Search engine",
        "VISIT_INFO_searchEngineProvider": "Search provider",
        "VISIT_INFO_searchEngineKeywords": "Search keywords",

        "VISIT_INFO_preChat": "Pre-chat survey",
        "VISIT_INFO_preChatQuestion": "Pre-chat survey question",
        "VISIT_INFO_postChat": "Post-chat survey",
        "VISIT_INFO_postChatQuestion": "Post-chat survey question",
        "VISIT_INFO_agentSurvey": "Agent survey",
        "VISIT_INFO_agentSurveyQuestion": "Agent survey question",
        "VISIT_INFO_customVariables": "Custom Variables",
        "VISIT_INFO_customVariable": "Custom Variable",

        "VISIT_INFO_leadGeneration": "Lead generation",
        "VISIT_INFO_topic": "Topic",
        "VISIT_INFO_value": "Value",
        "VISIT_INFO_leadId": "Lead ID",

        "VISIT_INFO_transaction": "Transaction",
        "VISIT_INFO_orderId": "Order ID",
        "VISIT_INFO_total": "Total",
        "VISIT_INFO_sku": "SKU",
        "VISIT_INFO_productName": "Product name",
        "VISIT_INFO_price": "Price",
        "VISIT_INFO_category": "Category",
        "VISIT_INFO_quantity": "Quantity",

        "VISIT_INFO_viewedProducts": "Viewed products",

        "VISIT_INFO_shoppingCartUpdate": "Shopping cart update",
        "VISIT_INFO_cartValue": "Total cart value",
        "VISIT_INFO_cartNumberOfItems": "Items",

        "VISIT_INFO_marketingInfo": "Marketing source",
        "VISIT_INFO_originatingChannel": "Originating channel",
        "VISIT_INFO_affiliate": "Affiliate",
        "VISIT_INFO_campaignId": "Campaign ID",

        "VISIT_INFO_personalInfo": "Personal info",
        "VISIT_INFO_personalName": "Name",
        "VISIT_INFO_age": "Age",
        "VISIT_INFO_birthday": "Birthday",
        "VISIT_INFO_gender": "Gender",
        "VISIT_INFO_company": "Company",
        "VISIT_INFO_address_region": "Region",
        "VISIT_INFO_address_country": "Country",
        "VISIT_INFO_phone": "Phone number",
        "VISIT_INFO_phoneType": "Phone type",
        "VISIT_INFO_email": "Email address",
        "VISIT_INFO_CONVERSATION_ID": "ID",
        "VISIT_INFO_CONVERSATION_START_TIME": "Start time",
        "VISIT_INFO_CONVERSATION_SOURCE": "Source",
        "VISIT_INFO_CONVERSATION_DEVICE": "Device",
        "VISIT_INFO_CONVERSATION_OS": "Operating System",
        "VISIT_INFO_CONVERSATION_BROWSER": "Browser",
        "VISIT_INFO_CONVERSATION_INFO": "Conversation info",
        "VISIT_INFO_CONSUMER_ID": "Consumer ID",

        "VISIT_INFO_SOURCE_facebook": "Facebook",
        "VISIT_INFO_SOURCE_sms": "SMS",
        "VISIT_INFO_SOURCE_line": "LINE",
        "VISIT_INFO_SOURCE_google": "Google",
        "VISIT_INFO_SOURCE_apple": "Apple Business Chat",
        "VISIT_INFO_SOURCE_whatsapp": "WhatsApp Business",
        "VISIT_INFO_SOURCE_rcs": "RCS Business Messaging",
        "VISIT_INFO_SOURCE_whc": "WHC",
        "VISIT_INFO_SOURCE_bmrcs": "bmrcs",
        "VISIT_INFO_SOURCE_plusmessage": "+Message",
        "VISIT_INFO_SOURCE_vfrcs": "vfrcs",
        "VISIT_INFO_SOURCE_interoprcs": "interOprcs",
        "VISIT_INFO_SOURCE_summitrcs": "summitrcs",
        "VISIT_INFO_SOURCE_cmccrcs": "cmccrcs",
        "VISIT_INFO_SOURCE_attrcs": "attrcs",
        "VISIT_INFO_SOURCE_orangercs": "orangercs",
        "VISIT_INFO_SOURCE_vzwrcs": "vzwrcs",
        "VISIT_INFO_SOURCE_wechat": "WeChat",

        "VISIT_INFO_customerInfo": "Customer info",
        "VISIT_INFO_customerStatus": "Status",
        "VISIT_INFO_customerType": "Type",
        "VISIT_INFO_customerId": "Customer ID",
        "VISIT_INFO_customerBalance": "Balance",
        "VISIT_INFO_customerRegistrationDate": "Registration",
        "VISIT_INFO_customerLastActivityDate": "Last payment date",
        "VISIT_INFO_customerSocialId": "Social ID",
        "VISIT_INFO_customerIMEI": "IMEI",
        "VISIT_INFO_customerUserName": "User Name",
        "VISIT_INFO_customerCompanySize": "Company Size",
        "VISIT_INFO_customerAccountName": "Account Name",
        "VISIT_INFO_customerRole": "Role",
        "VISIT_INFO_companyBranch": "Company branch",
        "VISIT_INFO_loginStatus": "Login status",
        "VISIT_INFO_storeZipCode": "Store Zip Code",
        "VISIT_INFO_storeNumber": "Store Number",
        "VISIT_INFO_language": "Language",

        "VISIT_INFO_GENDER_FEMALE": "Female",
        "VISIT_INFO_GENDER_MALE": "Male",
        "VISIT_INFO_GENDER_OTHER": "Other",

        "VISIT_INFO_visitorError": "Visitor error",
        "VISIT_INFO_error": "Error",
        "VISIT_INFO_message": "Message",
        "VISIT_INFO_code": "Code",
        "VISIT_INFO_level": "Level",
        "VISIT_INFO_contextId": "Context ID",
        "VISIT_INFO_resolved": "Resolved",

        "VISIT_INFO_serviceActivity": "Service activity",
        "VISIT_INFO_SAID": "ID",
        "VISIT_INFO_SATopic": "Topic",
        "VISIT_INFO_SAStatus": "Status",
        "VISIT_INFO_SACategory": "Category",

        "VISIT_INFO_searchedContent": "Searched content",

        "CONSUMER_INFO_consumerInfo": "Consumer info",
        "CONSUMER_INFO_consumerName": "Consumer name",
        "Messaging_session": "Messaging session",

        "RICH_TEXT_CHAT_INPUT_sanitizeMessage": "This content has been blocked within the Agent Workspace, but will be visible to your visitor once it is sent.",

        // CoBrowse:
        "CoBrowse" : "CoBrowse",
        "COBROWSE_INVITE_ACCEPT_BUTTON": "Accept",
        "COBROWSE_INVITE_REJECT_BUTTON": "Reject",

        "COBROWSE_MENU_ITEM_TITLE_VIEW_ONLY": "CoBrowse - View Only",
        "COBROWSE_MENU_ITEM_DESCRIPTION_VIEW_ONLY": "",
        "COBROWSE_MENU_ITEM_TITLE_SHARED": "CoBrowse - Shared",
        "COBROWSE_MENU_ITEM_DESCRIPTION_SHARED": "",
        "COBROWSE_MENU_ITEM_TITLE_END_SESSION": "CoBrowse - End Session",
        "COBROWSE_MENU_ITEM_DESCRIPTION_END_SESSION": "",

        "COBROWSE_NOTIFICATION_MESSAGE_VISITOR_PENDING_OFFER": "Visitor has a pending CoBrowse invitation.",
        "COBROWSE_NOTIFICATION_MESSAGE_VISITOR_ACCEPTED": "Visitor has accepted the CoBrowse invitation.",
        "COBROWSE_NOTIFICATION_MESSAGE_VISITOR_DECLINE": "Visitor has declined the CoBrowse invitation.",
        "COBROWSE_NOTIFICATION_MESSAGE_VISITOR_SESSION_END": "CoBrowse session has ended.",
        "COBROWSE_NOTIFICATION_MESSAGE_ERROR_OFFER_TIMED_OUT": "CoBrowse invitation has expired.",
        "COBROWSE_NOTIFICATION_MESSAGE_ERROR_SERVICE_UNAVAILABLE": "CoBrowse service is currently unavailable.",
        "COBROWSE_TRANSFER_DIALOG_MESSAGE" : "Transferring this engagement will end the CoBrowse session.",
        "COBROWSE_INVITE_MESSAGE_shared": "I have invited you to join a CoBrowse session, where I will be able to walk you through our website. To start, please click Accept.",
        "COBROWSE_INVITE_MESSAGE_view": "I have invited you to join a CoBrowse session, where I will be able to walk you through our website. To start, please click Accept.",
        "COBROWSE_NOTIFICATION_MESSAGE_ERROR_VISITOR_NOT_JOINED_SESSION": "Visitor has accepted the CoBrowse invitation but couldn't be connected.",
        "COBROWSE_NOTIFICATION_MESSAGE_VISITOR_JOINED_SESSION": "Visitor has joined the CoBrowse session.",
        "COBROWSE_NOTIFICATION_MESSAGE_VISITOR_LEFT_SESSION": "Visitor has left the CoBrowse session.",
        "COBROWSE_NOTIFICATION_MESSAGE_VISITOR_OFFER_REVOKED": "CoBrowse invitation retracted.",
        "COBROWSE_NOTIFICATION_MESSAGE_GENERIC_ERROR": "CoBrowse failed to connect.",
        "COBROWSE_NOTIFICATION_MESSAGE_ERROR_PENDING_REQUEST": "CoBrowse invitation has already been sent. Only one invitation can be sent at a time.",
        "COBROWSE_NOTIFICATION_MESSAGE_ERROR_ACTIVE_SESSION" : "CoBrowse session is already in progress.",
        "COBROWSE_RIBBON_TITLE" :  "CoBrowse Session",
        "VOICE_CALL_RIBBON_TITLE" :  "Voice call",
        "VIDEO_CALL_RIBBON_TITLE" :  "Video call",

        "CALL_NOTIFICATION_MESSAGE_VISITOR_SESSION_END" : "You were in a call with '{0}'",
        "CALL_NOTIFICATION_MESSAGE_ERROR_OFFER_TIMED_OUT" : "'{0}' missed your call",
        "CALL_NOTIFICATION_MESSAGE_VISITOR_DECLINE" : "'{0}' declined your call",

        "CONNECTIONS_STATE_FILTER_OPEN" : "Open",
        "CONNECTIONS_STATE_FILTER_FIRST_TIME" : "1st time consumer",
        "CONNECTIONS_STATE_FILTER_URGENT" : "Urgent",
        "CONNECTIONS_STATE_FILTER_OVERDUE" : "Open-overdue",
        "CONNECTIONS_STATE_FILTER_CLOSE" : "Closed (Agent/Consumer)",
        "CONNECTIONS_STATE_FILTER_IN_QUEUE" : "In Queue",


        // agent summary view
        "AGENT_SUMMARY_title": "Summary",

        //manual sla
        "MANUAL_SLA_minutes": "Minutes",
        "MANUAL_SLA_hours": "Hours",
        "MANUAL_SLA_days": "Days",
        "MANUAL_SLA_x_minutes": "{0} Minutes",
        "MANUAL_SLA_1_hour": "1 Hour",
        "MANUAL_SLA_x_hours": "{0} Hour",
        "MANUAL_SLA_1_day": "1 Day",
        "MANUAL_SLA_x_days": "{0} Days",
        "MANUAL_SLA_Change_SLA_manually": "Change response time manually:",
        "MANUAL_SLA_Header": "Response time was set manually and is now fixed. sent/received messages will not influence response time",
        "MANUAL_SLA_Restore": "Restore default response time ",

        "LABEL_custom": "Custom",
        "BUTTON_submit": "Submit",

        "RESUME_CONNECTION_errorTitle": "Unable to resume the connection",
        "RESUME_CONNECTION_errorDescription": "The connection cannot be resumed right now. Please try again later.",

        "ENGAGEMENT_HEADER_AUTHENTICATED_ICON_TOOLTIP" : "This customer is authenticated",
        "VERIFIED_DATA_TOOLTIP_SUFFIX" : " (Verified data)",

        "LAST_MESSAGE_TIME": "LAST MESSAGE TIME",
        "LAST_MESSAGE": "LAST MESSAGE",
        "CONVERSATION_START_TIME": "START TIME",
        "CONVERSATION_DEVICE": "DEVICE",
        "CONVERSATION_SOURCE_TOOLTIP": "Source",

        "takeover": "Takeover",
        "takeoverConversationTitle": "Takeover conversation",
        "takeoverConversationDescription": "You are about to takeover the conversation and assign it to yourself",
        "takingOverConversation": "Taking over conversation",
        "takeoverConversationError": "Takeover action can not be completed. <br/> Please try again",
        "takeoverConversationNotificationTitle": "Conversation was taken over",
        "takeoverConversationNotificationMessage": "Your conversation with {0} has been taken over by {1} and will no longer be visible.",

        //PCI FORM
        "secure_form_send_event_text":	"{0} has sent a Secure Form: {1}.",
        "secure_form_received_event_text" : "The visitor has received the Secure Form: {0}.",
        "secure_form_viewed_event_text": "The visitor has viewed the Secure Form: {0}.",
        "secure_form_agent_viewed_event_text": "The agent has viewed the Secure Form: {0}.",

        "secure_form_submit_event_text_generic": "The Secure Form has been submitted.",
        "secure_form_viewed_event_text_generic": "The consumer has viewed the Secure Form.",
        "secure_form_error_event_text_generic" : "There was an error while sending/receiving the Secure Form.",

        "secure_form_submmitted_text" : "The form has been sent successfully. <br/> To protect your information, submitted forms cannot be reopened.",
        "secure_form_submit_event_text": "The following Secure Form has been submitted: {0}.",
        "secure_form_error_event_text" : "There was an error while sending/receiving the Secure Form: {0}.",
        "secure_form_aborted_event_text" : "The following Secure Form has expired: {0}.",
        "secure_form_expired_text" : "The Secure Form has expired. Please contact your agent for assistance.",

        "secure_forms_list_errorMessage": "Could not load Secure Forms.",
        "secure_forms_list_error_refresh": "Reload",
        "secure_forms_list_errorInfoLink": "",

        "secure_forms_history_errorMessage": "The chat has ended and you no longer have permission to access this form.",
        "secure_forms_iframe_errorMessage": "Could not load Secure Form.",
        "secure_forms_iframe_errorMessage_form_calculation": "The secure form has failed to load. <br/> When loading the form, please remain on the page until loading completes.",
        "secure_forms_iframe_error_refresh": "Reload",
        "secure_forms_iframe_errorInfoLink": "",

        "predefined_content_errorMessage": "Could not load Predefined messages.",
        "predefined_content_error_refresh": "Reload",
        "predefined_content_errorInfoLink": "",

        "predefined_content_tab_tooltip": "Predefined messages",
        "secure_forms_tab_tooltip": "Secure Forms",
        "secure_forms_tooltip": "Click to send the Secure Form",

        "secure_forms_init_state_text" : "The Secure Form <strong class=\'lpview_secure_forms_init_state_text_form_name\'></strong> has been submitted.",
        "secure_forms_init_state_display_button": "View Secure Form",

        "secure_forms_logo_tooltip": "This Secure Form is PCI DSS compliant.",
        "secure_forms_header_title" : "This is a Secure Form",
        "secure_forms_header_description": "Details provided here are protected.",

        //IDNV
        "idnv_dropup": " Enter characters {0} and {1} {2} from your {3}",
        "idnv_message": " Please enter characters {0} and {1} from your {2}.",
        "idnv_submit_button_tooltip": "Complete all fields before you send.",
        "idnv_tooltip": "Click to send an identification question.",
        "idnv_numeric_input_tooltip":  "Please enter number between 1 and 99",

        //Photo_sharing
        "photo_sharing_image_caption": "image",
        "photo_sharing_image_notification": "|image| {0}",
        "photo_sharing_view_index": "{0} out of {1} ",
        "photo_sharing_view_error": "Error loading image",

        // Audio Messaging
        "audio_messaging_caption": "audio",
        "audio_messaging_notification": "Audio Message",

        //Post conv survey filter
        "history_search_filter_status": "Status",
        "history_search_filter_start_time": "Start time",
        "history_search_filter_skill": "Skill",
        "history_search_filter_agent_group": "Agent group",
        "history_search_filter_agent_MCS": "MCS",
        "history_search_filter_agent_Csat": "CSAT",
        "history_search_filter_device": "Device",
        "history_search_filter_source": "Source",
        "history_search_filter_agent_name": "Agent name",
        "history_search_filter_duration": "Duration",
        "history_search_filter_survey_attributes": "Post Conversation Survey Attributes",
        "history_search_filter_survey_bot_conversations": "Display only survey bot conversations",
        "history_search_filter_survey": "Survey",
        "history_search_filter_survey_name": "Name",
        "history_search_filter_survey_id": "ID",
        "history_search_filter_survey_enter_id": "Enter ID",
        "history_search_filter_question_brick": "Question brick",
        "history_search_filter_nps": "NPS",
        "history_search_filter_fcr": "FCR",
        "history_search_filter_fcr_yes": "Yes",
        "history_search_filter_fcr_no": "No",
        "history_search_filter_invalid_free_text_answer": "Display conversations with invalid response by consumer",
        "history_search_filter_open_question_answered": "Display conversation with free text question answered",
        "history_search_filter_free_text_answer": "Answer text",
        "history_search_filter_question_brick_name_or_id": "Enter brick name or ID",
        "history_search_filter_free_text_answer_separator": "or",
        "history_search_numeric_range_validation_error": "Invalid range, 'From' can't be greater than 'To'",

        //Agent survey filter
        "history_search_filter_agent_survey_attributes": "Agent Survey Attributes",

        "history_search_filter_agent_survey_question": "Question",
        "history_search_filter_agent_survey_question_tooltip": "Filter by survey question keywords",

        "history_search_filter_pending_agent_survey": "Pending Survey",
        "history_search_filter_pending_agent_survey_tooltip": "Filter by pending survey",
        "history_search_filter_pending_agent_survey_yes": "Yes",
        "history_search_filter_pending_agent_survey_no": "No",

        "history_search_filter_agent_survey_answer": "Answer text",
        "history_search_filter_agent_survey_answer_tooltip": "Filter by survey answer keywords",

        "statusFilterStateOpen": "Open",
        "statusFilterStateClose": "Closed",
        "statusFilterStateLocked": "Locked",
        "deviceFilterStateTablet": "Tablet",
        "deviceFilterStateDesktop": "Desktop",
        "deviceFilterStateMobile": "Mobile",
        "deviceFilterStateNA": "NA",
        "sourceFilterStateApp": "App",
        "sourceFilterStateWeb": "Web",
        "sourceFilterStateAgent": "Agent",
        "sourceFilterStateSMS": "SMS",
        "sourceFilterStateFacebook": "Facebook",
        "conversationInQueueFilter": "Display only in queue conversations",

        //Content Preview
        "content_preview_not_participant_error" : "This message cannot be sent because you are not a participant in this conversation. Please join the conversation and try again.",
        "content_preview_error_title": "Unable to send Content",
        "content_preview_error_msg": "Preview failed to load.<br>Please contact your account administrator.",
        "content_preview_conv_close_error": "This message cannot be sent because the conversation has been closed. Please reopen the conversation and try again.",

        //Structured Content
        "structured_content_error_title": "Unable to send Structured Content",
        "structured_content_preview_error_msg": "Preview failed to load.<br>Please contact your account administrator.",
        "structured_content_length_limit_error": "This message exceeds the {0} character limit and cannot be sent. Please reduce the number of characters and try again.",
        "structured_content_conv_close_error": "This message cannot be sent because the conversation has been closed. Please reopen the conversation and try again.",
        "structured_content_not_participant_error": "This message cannot be sent because you are not a participant in this conversation. Please join the conversation and try again.",
        "structured_content_plain_text": "Rich Content",
        "structured_content_render_error_title": "Oops!",
        "structured_content_render_error_description": "This card failed to load.",
        "structured_content_unauthorized_content_error": "Your message contains unauthorized content and therefore was not sent to the consumer. Please review your content or contact your administrator.",

        //Quick Replies
        "quick_replies_action_reported_message": "The consumer has clicked a button",
        "quick_replies_render_error_title": "Oops!",
        "quick_replies_render_error_description": "The quick replies failed to load.",
        "quick_replies_not_supported_for_live_chat" : "Message type not supported in chat",

        //Bot Escalation
        "bot_escalation_visitor_info_title": "Bot Escalation Summary",
        "bot_escalation_visitor_info_topics": "Identified topics",
        "bot_escalation_visitor_info_score": "Confidence Score",
        "bot_escalation_visitor_info_reason": "Escalation reason:",
        "bot_escalation_visitor_info_duration": "Conversation duration:",
        "bot_escalation_visitor_info_last_topic": "Escalation to human agent",
        "bot_escalation_chat_bubble_title": "Bot conversation recap",
        "bot_escalation_chat_bubble_topics": "Identify topics:",
        "bot_escalation_chat_bubble_reason": "Escalation reason:",
        "bot_escalation_chat_bubble_duration": "Conversation duration:",

        //amex - Online Presence
        "presence_online": "Online",
        "presence_today": "Last seen today at {0}",
        "presence_yesterday": "Last seen yesterday at {0}",
        "presence_old": "Last seen {0}",

        "agent_deleted_indication": "(Deleted)",

        //visit info widget default tooltips
        "goal.default.name": "Interact with visitors",
        "goal.default.description": "Measure the number of interactive chats and clicks on content",
        "visitorBehavior.default.name": "All behaviors (recommended)",
        "visitorBehavior.default.description": "Allows you to target all of this campaign's target audience regardless of visitor behavior",
        "visitorProfile.default.name": "All visitors",
        "visitorProfile.default.description": "Automatically created default target audience. Targets the high value visitors in your website.",

        "chatLine.state.tooltip.profane": "Message contains prohibited content and has been blocked.",
        "chatLine.state.tooltip.validationFailedServer": "Your text contains invalid characters and therefore was not sent to the consumer. Please review your content and try again.",

        "richTextChatLineInput.invalidInputWarningDialog.title" : "Warning",
        "richTextChatLineInput.invalidInputWarningDialog.message" : "Your text contains invalid characters and cannot be submitted. Please review your content and try again.",

        "fileSharing.error.fileType": "{0} file type is not supported on the consumer's current channel. Please select supported file types: {1}",
        "fileSharing.errorTitle.fileType": "Unsupported file type",
        "fileSharing.error.fileSize": "File size exceeds the {0} MB limitation",
        "fileSharing.errorTitle.fileSize": "Unsupported file size",
        "fileSharing.tooltip.send": "Add attachment",
        "fileSharing.tooltip.disabled": "Consumer cannot receive files",
        "fileSharing.tooltip.retry": "Failed to send file. Click to retry",
        "fileSharing.tooltip.error": "Failed to send file",
        "fileSharing.tooltip.download": "Download",
        "fileSharing.addCaption": "Add a caption",
        "fileSharing.preview": "Preview",
        "fileSharing.unknown_file": "UNKNOWN",
        "fileSharing.no_preview": "No preview available for this file. Click to download",
        "fileSharing.file_messaging_notification": "|file| {0}",
        "fileSharing.file_messaging_caption": "file",

        "reply.message.tooltip":"This message was sent using the reply feature.",

        // AI Assist / Maven text strings
        "ai_assist_recommended_automations": "",
        "ai_assist_maven": "",
        "ai_assist_no_automations": "No automations to suggest.",
        "ai_assist_waiting_for_messages": "Waiting on further messages",
        "ai_assist_intent": "Intent",
        "ai_assist_relevance": "Relevance",
        "ai_assist_response": "Response",
        "ai_assist_vote_up": "Vote up",
        "ai_assist_vote_down": "Vote down",
        "ai_assist_send": "Send",
        "ai_assist_bad_intent": "The intent was misunderstood",
        "ai_assist_bad_bot": "The bot does not match the intent",
        "ai_assist_score_high": "High",
        "ai_assist_score_medium": "Medium",
        "ai_assist_score_low": "Low",
        "ai_assist_transfer": "Transfer",
        "ai_assist_bot_can_assist": "{0} can assist",
        "ai_assist_show_more": "Show More",
        "ai_assist_use_article": "Use Article",
        "ai_assist_select_reason": "Select a reason or type your own",
        "ai_assist_dropdown": "Dropdown",
        "ai_assist_bot_is_assisting": "{0} is assisting the visitor.",
        "ai_assist_bot_remove_bot": "You can remove the bot from the conversation at any time.",
        "ai_assist_paused": "Recommended actions are paused while a bot is in the conversation.",
        "ai_assist_join": "Join",
        "ai_assist_remove": "Remove",
        "ai_assist_remove_bot_from_conversation": "Remove bot from conversation",

        //PCS close reason
        "post_conversation_survey_expired": "Survey expired",
        "post_conversation_survey_completed": "Survey completed",
        "post_conversation_survey_skipped": "Survey skipped",
        "post_conversation_survey_closed": "Survey closed",

        //Smart suggestions & auto complete
        "smart_suggestions.nothing_to_suggest": "Nothing to suggest",

        // messaging agent survey
        "submit": "Submit",
        "resubmit": "Resubmit",
        "dismiss": "Dismiss",

        "newAgentWorkspaceInvitation": "Try our new agent workspace",

        "messagingAgentSurvey.tabs.previously_submitted": "Previously submitted",
        "messagingAgentSurvey.tabs.previously_submitted.tooltip": "View previously submitted surveys for this conversation",
        "messagingAgentSurvey.tabs.current": "Current",

        "messagingAgentSurvey.engagementAttributes.lead.leadId": "Lead ID",
        "messagingAgentSurvey.engagementAttributes.lead.currency": "Currency",
        "messagingAgentSurvey.engagementAttributes.lead.topic": "Topic",
        "messagingAgentSurvey.engagementAttributes.lead.value": "Value",

        "messagingAgentSurvey.engagementAttributes.service_activity.serviceId": "Service ID",
        "messagingAgentSurvey.engagementAttributes.service_activity.category": "Category",
        "messagingAgentSurvey.engagementAttributes.service_activity.status": "Status",
        "messagingAgentSurvey.engagementAttributes.service_activity.topic": "Topic",

        "messagingAgentSurvey.engagementAttributes.transaction.total": "Order total",
        "messagingAgentSurvey.engagementAttributes.transaction.currency": "Currency",
        "messagingAgentSurvey.engagementAttributes.transaction.orderId": "Order ID",

        "messagingAgentSurvey.previouslySubmitted.skill_title": "Skill: {0}",
        "messagingAgentSurvey.previouslySubmitted.submitted_by": "by {0}",

        "messagingAgentSurvey.error.missing_required_questions_on_submit": "Survey can't be submitted. The following required questions are missing: {0}",
        "messagingAgentSurvey.error.no_submit_empty_survey": "Cannot submit an empty survey",
        "messagingAgentSurvey.error.invalid_form": "You have errors in your form. Please review the form and try again",

        "messagingAgentSurvey.error.no_permission_to_submit_survey": "You do not have permissions to submit the agent survey",
        "messagingAgentSurvey.error.no_permission_to_dismiss_survey": "You do not have permissions to dismiss the agent survey",

        "messagingAgentSurvey.error.submit_wrong_revision": "Could not submit the survey, please refresh and try again",
        "messagingAgentSurvey.error.dismiss_wrong_revision": "Could not dismiss the survey, please refresh and try again",

        "messagingAgentSurvey.error.survey_was_modified": "This survey was modified by another user, please refresh",
        "messagingAgentSurvey.error.default_save_error": "Could not save the survey, please refresh and try again",
        "messagingAgentSurvey.error.default_submit_error": "There was an error submitting the survey",
        "messagingAgentSurvey.error.default_dismiss_error": "There was an error dismissing the survey",
        "messagingAgentSurvey.error.default_load_survey_error": "Could not load the survey, please try again",

        "messagingAgentSurvey.warning.dismiss_agent_survey.title": "Dismiss agent survey",
        "messagingAgentSurvey.warning.dismiss_agent_survey.content": "Please note that upon dismissing the agent survey, you will not be able to view or submit the survey.<br><br>Are you sure you want to dismiss?",
        "messagingAgentSurvey.warning.dismiss_agent_survey.dismiss_button": "Yes, dismiss",

        "messagingAgentSurvey.warning.transfer_pending_survey.title": "Pending survey conversation",
        "messagingAgentSurvey.warning.transfer_pending_survey.content": "Please note that you are transferring a pending survey conversation.<br>By transferring the conversation to a different skill, this survey will be closed.<br><br>Are you sure you want to continue?",
        "messagingAgentSurvey.warning.transfer_pending_survey.transfer_button": "Yes, transfer",

        "messagingAgentSurvey.warning.resume_pending_survey.title": "Pending survey conversation",
        "messagingAgentSurvey.warning.resume_pending_survey.content": "Please note that you are resuming a conversation with a pending survey.<br>By resuming, this survey will be closed.<br><br>Are you sure you want to continue?",
        "messagingAgentSurvey.warning.resume_pending_survey.resume_button": "Yes, resume",

        "messagingAgentSurvey.warning.return_to_queue_pending_survey.title": "Pending survey conversation",
        "messagingAgentSurvey.warning.return_to_queue_pending_survey.content": "Please note that you are returning a conversation with a pending survey to queue.<br><br>Are you sure you want to continue?",
        "messagingAgentSurvey.warning.return_to_queue_pending_survey.return_button": "Yes, return",

        "messagingAgentSurvey.warning.bad_content.title": "Warning",
        "messagingAgentSurvey.warning.bad_content.content": "Your answers contain invalid characters and cannot be submitted. Please review your content and try again. The following answers are invalid: {0}",

        "messagingAgentSurvey.warning.conversation_returned_to_queue.title": "Conversation was transferred",
        "messagingAgentSurvey.warning.conversation_returned_to_queue": "This conversation was transferred. The survey will be available again once an agent is assigned.",

        "messagingAgentSurvey.fieldError.missing_required_field": "Missing required field",
        "messagingAgentSurvey.fieldError.missing_required_fields": "Missing required fields",
        "messagingAgentSurvey.fieldError.illegal_date_value": "Illegal date value",
        "messagingAgentSurvey.fieldError.date_out_of_range": "Date out of range",

        "messagingAgentSurvey.success.submit_survey": "Submitted at: {0}",
        "messagingAgentSurvey.success.dismiss_survey": "Survey was dismissed at: {0}",

        "messagingAgentSurvey.disabled.survey_timeout": "Survey expired at: {0}",
        "messagingAgentSurvey.disabled.timeout_state": "This survey has expired and is now disabled",
        "messagingAgentSurvey.info.no_survey_configured": "No survey is configured for this conversation",
        "messagingAgentSurvey.info.no_survey_available": "No survey is available for this conversation",

        "messagingAgentSurvey.info.no_permission_to_view_survey": "You do not have permissions to view agent survey",
        "messagingAgentSurvey.info.no_permission_to_submit_survey": "You do not have permissions to submit agent survey",

        "messagingAgentSurvey.info.no_previously_submitted_surveys": "No previously submitted surveys to display for this conversation",
        "messagingAgentSurvey.error.previously_submitted_default_error": "There was an error retrieving the previously submitted surveys. Please refresh",

        "messagingAgentSurvey.pending_survey_badge.tooltip": "Pending survey",

      "service.activity.status.placeholder": "Select",
      "service.activity.status.complete.label": "Complete",
      "service.activity.status.in_progress.label": "In progress",
      "service.activity.status.approved.label": "Approved",
      "service.activity.status.cancelled.label": "Cancelled",
      "service.activity.status.not_approved.label": "Not approved",
      "service.activity.status.reviewed.label": "Reviewed",
      "service.activity.status.missing_details.label": "Missing details",
      "service.activity.status.closed.label": "Closed",
      "service.activity.status.removed.label": "Removed",
      "service.activity.status.assigned.label": "Assigned",
      "service.activity.status.waiting_for_customer_response.label": "Waiting for customer response", //// MYWORD_COMPANY_LENGTH_30
      "service.activity.status.waiting_for_response.label": "Waiting for response", //// MYWORD_COMPANY_LENGTH_30
      "service.activity.status.pending.label": "Pending",
      "service.activity.status.resolved.label": "Resolved",
    };

    return Dictionary;
});
